import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_common_proto from './dcei_wildsky_common_proto';
export class Filter {
  get descriptor() {
    return Filter.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPlayerLevel = false;
    this._playerLevel = null;
    this._preconditions = [];
    this._hasHasMineFloor = false;
    this._hasMineFloor = null;
    this._hasHasMapEventCoopLevel = false;
    this._hasMapEventCoopLevel = null;
    this._hasVersion = false;
    this._version = null;
  }
  isEmpty() {
    if (this._hasPlayerLevel && !this._playerLevel.isEmpty()) return false;
    if (this._preconditions.length > 0) return false;
    if (this._hasHasMineFloor) return false;
    if (this._hasHasMapEventCoopLevel) return false;
    if (this._hasVersion) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Filter) {
      return value;
    }
    return Filter.fromJson(value);
  }
  static fromJson(json) {
    const result = new Filter();
    if (json.playerLevel != null) {
      result._hasPlayerLevel = true;
      result._playerLevel = dcei_wildsky_common_proto.IntRange.fromJson(json.playerLevel);
    }
    result._preconditions = JsonToList(json.preconditions, JsonToString);
    if (json.hasMineFloor != null) {
      result._hasHasMineFloor = true;
      result._hasMineFloor = JsonToBoolean.fromJson(json.hasMineFloor);
    }
    if (json.hasMapEventCoopLevel != null) {
      result._hasHasMapEventCoopLevel = true;
      result._hasMapEventCoopLevel = JsonToBoolean.fromJson(json.hasMapEventCoopLevel);
    }
    if (json.version != null) {
      result._hasVersion = true;
      result._version = JsonToString.fromJson(json.version);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPlayerLevel && !this._playerLevel.isEmpty()) {
      result.playerLevel = dcei_wildsky_common_proto.IntRange.toJson(this._playerLevel);
    }
    if (this._preconditions.length > 0) {
      result.preconditions = ArrayToJson(this._preconditions, JsonToString);
    }
    if (this._hasHasMineFloor) {
      result.hasMineFloor = JsonToBoolean.toJson(this._hasMineFloor);
    }
    if (this._hasHasMapEventCoopLevel) {
      result.hasMapEventCoopLevel = JsonToBoolean.toJson(this._hasMapEventCoopLevel);
    }
    if (this._hasVersion) {
      result.version = JsonToString.toJson(this._version);
    }
    return result;
  }
  /**
   * @returns {dcei_wildsky_common_proto.IntRange}
   */
  get playerLevel() {
    return this._hasPlayerLevel ? this._playerLevel : dcei_wildsky_common_proto.IntRange.default;
  }
  get hasPlayerLevel() {
    return this._hasPlayerLevel;
  }
  setPlayerLevel(path, value) {
    return {type: 'SET', path: path.concat(['playerLevel']), value: value.toJson()};
  }
  deletePlayerLevel(path) {
    return {type: 'DELETE', path: path.concat(['playerLevel'])};
  }
  /**
   * @returns {string[]}
   */
  get preconditions() {
    return this._preconditions;
  }
  addPreconditions(path, value) {
    return {type: 'ADD', path: path.concat(['preconditions']), value};
  }
  setPreconditions(path, value) {
    return {type: 'SET', path: path.concat(['preconditions']), value: ArrayToJson(value, JsonToString)};
  }
  setPreconditionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['preconditions', key]), value};
  }
  deletePreconditions(path) {
    return {type: 'DELETE', path: path.concat(['preconditions'])};
  }
  deletePreconditionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['preconditions', key])};
  }
  /**
   * @returns {boolean}
   */
  get hasMineFloor() {
    return this._hasHasMineFloor ? this._hasMineFloor : JsonToBoolean.default;
  }
  get hasHasMineFloor() {
    return this._hasHasMineFloor;
  }
  setHasMineFloor(path, value) {
    return {type: 'SET', path: path.concat(['hasMineFloor']), value};
  }
  deleteHasMineFloor(path) {
    return {type: 'DELETE', path: path.concat(['hasMineFloor'])};
  }
  /**
   * @returns {boolean}
   */
  get hasMapEventCoopLevel() {
    return this._hasHasMapEventCoopLevel ? this._hasMapEventCoopLevel : JsonToBoolean.default;
  }
  get hasHasMapEventCoopLevel() {
    return this._hasHasMapEventCoopLevel;
  }
  setHasMapEventCoopLevel(path, value) {
    return {type: 'SET', path: path.concat(['hasMapEventCoopLevel']), value};
  }
  deleteHasMapEventCoopLevel(path) {
    return {type: 'DELETE', path: path.concat(['hasMapEventCoopLevel'])};
  }
  /**
   * @returns {string}
   */
  get version() {
    return this._hasVersion ? this._version : JsonToString.default;
  }
  get hasVersion() {
    return this._hasVersion;
  }
  setVersion(path, value) {
    return {type: 'SET', path: path.concat(['version']), value};
  }
  deleteVersion(path) {
    return {type: 'DELETE', path: path.concat(['version'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "playerLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Filter(this);
              copy._hasPlayerLevel = true;
              copy._playerLevel = dcei_wildsky_common_proto.IntRange.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerLevel) {
                return this;
              }
              const copy = new Filter(this);
              copy._hasPlayerLevel = false;
              copy._playerLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPlayerLevel) {
            const copy = new Filter(this);
            copy._hasPlayerLevel = true;
            copy._playerLevel = dcei_wildsky_common_proto.IntRange.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._playerLevel.apply(type, path.slice(1), value);
          if (newValue === this._playerLevel) {
            return this;
          }
          const copy = new Filter(this);
          copy._playerLevel = copy._playerLevel.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "preconditions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Filter(this);
              copy._preconditions = [];        for (let i of value) {
                copy._preconditions.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Filter(this);
              copy._preconditions = copy._preconditions.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._preconditions.length === 0) {
                return this;
              }
              const copy = new Filter(this);
              copy._preconditions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._preconditions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Filter(this);
              copy._preconditions = copy._preconditions.slice();
              copy._preconditions[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Filter(this);
              copy._preconditions = copy._preconditions.slice(0, path[1]).concat(copy._preconditions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._preconditions.length) {
            return this;
          }
          const oldValue = this._preconditions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Filter(this);
          copy._preconditions = copy._preconditions.slice();
          copy._preconditions[key] = newValue;
          return copy;
        }
      }
      case "hasMineFloor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Filter(this);
              copy._hasHasMineFloor = true;
              copy._hasMineFloor = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHasMineFloor) {
                return this;
              }
              const copy = new Filter(this);
              copy._hasHasMineFloor = false;
              copy._hasMineFloor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "hasMapEventCoopLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Filter(this);
              copy._hasHasMapEventCoopLevel = true;
              copy._hasMapEventCoopLevel = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHasMapEventCoopLevel) {
                return this;
              }
              const copy = new Filter(this);
              copy._hasHasMapEventCoopLevel = false;
              copy._hasMapEventCoopLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "version": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Filter(this);
              copy._hasVersion = true;
              copy._version = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasVersion) {
                return this;
              }
              const copy = new Filter(this);
              copy._hasVersion = false;
              copy._version = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Filter} other
   * @returns {Filter}
   */
  merge(other) {
    const copy = new Filter(this);
    if (other._hasPlayerLevel) {
      if (copy._hasPlayerLevel) {
        copy._playerLevel = copy.playerLevel.merge(other.playerLevel);
      } else {
        copy._playerLevel = other._playerLevel;
      }
      copy._hasPlayerLevel = true;
    }
    copy._preconditions = this._preconditions.concat(other._preconditions);
    if (other._hasHasMineFloor) {
      copy._hasHasMineFloor = true;
      copy._hasMineFloor = other._hasMineFloor;
    }
    if (other._hasHasMapEventCoopLevel) {
      copy._hasHasMapEventCoopLevel = true;
      copy._hasMapEventCoopLevel = other._hasMapEventCoopLevel;
    }
    if (other._hasVersion) {
      copy._hasVersion = true;
      copy._version = other._version;
    }
    return copy;
  }
}
Filter.default = new Filter();
class Filter_Builder {
  constructor(value) {
    this._value = new Filter(value);
  }
  build() {
    return new Filter(this._value);
  }
  setPlayerLevel(value) {
    this._value._hasPlayerLevel = true;
    this._value._playerLevel = value;
    return this;
  }
  deletePlayerLevel() {
    this._value._hasPlayerLevel = false;
    this._value._playerLevel = null;
    return this;
  }
  addAllPreconditions(values) {
    this._value._preconditions = this._value._preconditions.concat(values);
    return this;
  }
  addPreconditions(value) {
    this._value._preconditions = this._value._preconditions.concat([value]);
    return this;
  }
  setPreconditions(index, value) {
    this._value._preconditions = this._value._preconditions.concat();
    this._value._preconditions[index] = value;
    return this;
  }
  clearPreconditions() {
    this._value._preconditions = [];
    return this;
  }
  setHasMineFloor(value) {
    this._value._hasHasMineFloor = true;
    this._value._hasMineFloor = value;
    return this;
  }
  deleteHasMineFloor() {
    this._value._hasHasMineFloor = false;
    this._value._hasMineFloor = null;
    return this;
  }
  setHasMapEventCoopLevel(value) {
    this._value._hasHasMapEventCoopLevel = true;
    this._value._hasMapEventCoopLevel = value;
    return this;
  }
  deleteHasMapEventCoopLevel() {
    this._value._hasHasMapEventCoopLevel = false;
    this._value._hasMapEventCoopLevel = null;
    return this;
  }
  setVersion(value) {
    this._value._hasVersion = true;
    this._value._version = value;
    return this;
  }
  deleteVersion() {
    this._value._hasVersion = false;
    this._value._version = null;
    return this;
  }
}
Filter.Builder = Filter_Builder;
class Filter_WithParent {
  /**
   * @param {Filter} value
   * @param {Filter_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Filter.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPlayerLevel() {
    if (this._cachedHasPlayerLevel === undefined) {
      if (this._value.hasPlayerLevel) {
        this._cachedHasPlayerLevel = true;
      } else {
        this._cachedHasPlayerLevel = this._parent ? this._parent.hasPlayerLevel : false;
      }
    }
    return this._cachedHasPlayerLevel;
  }
  get playerLevel() {
    if (!this._cachedPlayerLevel) {
      if (this._value.hasPlayerLevel) {
        this._cachedPlayerLevel = new dcei_wildsky_common_proto.IntRange.WithParent(this._value.playerLevel, this._parent && this._parent.hasPlayerLevel ? this._parent.playerLevel : null);
      } else {
        this._cachedPlayerLevel = this._parent ? new dcei_wildsky_common_proto.IntRange.WithParent(dcei_wildsky_common_proto.IntRange.default, this._parent.playerLevel) : dcei_wildsky_common_proto.IntRange.WithParent.default;
      }
    }
    return this._cachedPlayerLevel;
  }
  get selfPreconditions() {
    return this._value.preconditions;
  }
  get inherentPreconditions() {
    if (!this._inherentPreconditions) {
      this._inherentPreconditions = this._parent ? this._parent.preconditions : [];
    }
    return this._inherentPreconditions;
  }
  get preconditions() {
    if (!this._allPreconditions) {
      this._allPreconditions = this._parent ? this._parent.preconditions.concat(this.selfPreconditions) : this.selfPreconditions;
    }
    return this._allPreconditions;
  }
  get hasHasMineFloor() {
    if (this._cachedHasHasMineFloor === undefined) {
      if (this._value.hasHasMineFloor) {
        this._cachedHasHasMineFloor = true;
      } else {
        this._cachedHasHasMineFloor = this._parent ? this._parent.hasHasMineFloor : false;
      }
    }
    return this._cachedHasHasMineFloor;
  }
  get hasMineFloor() {
    if (this._cachedHasMineFloor === undefined) {
      if (this._value.hasHasMineFloor) {
        this._cachedHasMineFloor = this._value.hasMineFloor;
      } else {
        this._cachedHasMineFloor = this._parent ? this._parent.hasMineFloor : this._value.hasMineFloor;
      }
    }
    return this._cachedHasMineFloor;
  }
  get hasHasMapEventCoopLevel() {
    if (this._cachedHasHasMapEventCoopLevel === undefined) {
      if (this._value.hasHasMapEventCoopLevel) {
        this._cachedHasHasMapEventCoopLevel = true;
      } else {
        this._cachedHasHasMapEventCoopLevel = this._parent ? this._parent.hasHasMapEventCoopLevel : false;
      }
    }
    return this._cachedHasHasMapEventCoopLevel;
  }
  get hasMapEventCoopLevel() {
    if (this._cachedHasMapEventCoopLevel === undefined) {
      if (this._value.hasHasMapEventCoopLevel) {
        this._cachedHasMapEventCoopLevel = this._value.hasMapEventCoopLevel;
      } else {
        this._cachedHasMapEventCoopLevel = this._parent ? this._parent.hasMapEventCoopLevel : this._value.hasMapEventCoopLevel;
      }
    }
    return this._cachedHasMapEventCoopLevel;
  }
  get hasVersion() {
    if (this._cachedHasVersion === undefined) {
      if (this._value.hasVersion) {
        this._cachedHasVersion = true;
      } else {
        this._cachedHasVersion = this._parent ? this._parent.hasVersion : false;
      }
    }
    return this._cachedHasVersion;
  }
  get version() {
    if (this._cachedVersion === undefined) {
      if (this._value.hasVersion) {
        this._cachedVersion = this._value.version;
      } else {
        this._cachedVersion = this._parent ? this._parent.version : this._value.version;
      }
    }
    return this._cachedVersion;
  }
  update(current, parent) {
    const result = new Filter_WithParent(current, parent);
    if (this._cachedPlayerLevel && this._value.hasPlayerLevel && current.hasPlayerLevel) {
      if (this._value.playerLevel === current.playerLevel && this._parent === parent) {
        result._cachedPlayerLevel = this._cachedPlayerLevel;
      } else {
        result._cachedPlayerLevel = this._cachedPlayerLevel.update(current.playerLevel, parent && parent.hasPlayerLevel ? parent.playerLevel : null);
      }
    }
    return result;
  }
}
Filter_WithParent.default = new Filter_WithParent(Filter.default, null);
Filter.WithParent = Filter_WithParent;
class Filter_Descriptor {
  get playerLevel() {
    if (!this._playerLevel) {
      this._playerLevel = {
        name: "playerLevel",
        Name: "PlayerLevel",
        number: 1,
        protoType: 11,
        protoName: "player_level",
        type: dcei_wildsky_common_proto.IntRange,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerLevel;
  }
  get preconditions() {
    if (!this._preconditions) {
      this._preconditions = {
        name: "preconditions",
        Name: "Preconditions",
        number: 3,
        protoType: 9,
        protoName: "preconditions",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "QuestAndAchievementNameList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._preconditions;
  }
  get hasMineFloor() {
    if (!this._hasMineFloor) {
      this._hasMineFloor = {
        name: "hasMineFloor",
        Name: "HasMineFloor",
        number: 4,
        protoType: 8,
        protoName: "has_mine_floor",
        type: JsonToBoolean,
        options: {
          comments: "This flag is to indicate that this filter will only pass when at least 1 mine floor can be beat",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hasMineFloor;
  }
  get hasMapEventCoopLevel() {
    if (!this._hasMapEventCoopLevel) {
      this._hasMapEventCoopLevel = {
        name: "hasMapEventCoopLevel",
        Name: "HasMapEventCoopLevel",
        number: 5,
        protoType: 8,
        protoName: "has_map_event_coop_level",
        type: JsonToBoolean,
        options: {
          comments: "This flag is to indicate that this filter will only pass when there\'s a current live event",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hasMapEventCoopLevel;
  }
  get version() {
    if (!this._version) {
      this._version = {
        name: "version",
        Name: "Version",
        number: 6,
        protoType: 9,
        protoName: "version",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._version;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.playerLevel,
        this.preconditions,
        this.hasMineFloor,
        this.hasMapEventCoopLevel,
        this.version,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPlayerLevel",
        Name: "DummyOneofForPlayerLevel",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHasMineFloor",
        Name: "DummyOneofForHasMineFloor",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHasMapEventCoopLevel",
        Name: "DummyOneofForHasMapEventCoopLevel",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForVersion",
        Name: "DummyOneofForVersion",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
Filter.descriptor = new Filter_Descriptor();
export class QuestActivePointChest {
  get descriptor() {
    return QuestActivePointChest.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasRequiredPoints = false;
    this._requiredPoints = null;
    this._rewardPatterns = [];
  }
  isEmpty() {
    if (this._hasRequiredPoints) return false;
    if (this._rewardPatterns.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof QuestActivePointChest) {
      return value;
    }
    return QuestActivePointChest.fromJson(value);
  }
  static fromJson(json) {
    const result = new QuestActivePointChest();
    if (json.requiredPoints != null) {
      result._hasRequiredPoints = true;
      result._requiredPoints = JsonToInt32.fromJson(json.requiredPoints);
    }
    result._rewardPatterns = JsonToList(json.rewardPatterns, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasRequiredPoints) {
      result.requiredPoints = JsonToInt32.toJson(this._requiredPoints);
    }
    if (this._rewardPatterns.length > 0) {
      result.rewardPatterns = ArrayToJson(this._rewardPatterns, JsonToString);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get requiredPoints() {
    return this._hasRequiredPoints ? this._requiredPoints : JsonToInt32.default;
  }
  get hasRequiredPoints() {
    return this._hasRequiredPoints;
  }
  setRequiredPoints(path, value) {
    return {type: 'SET', path: path.concat(['requiredPoints']), value};
  }
  deleteRequiredPoints(path) {
    return {type: 'DELETE', path: path.concat(['requiredPoints'])};
  }
  /**
   * @returns {string[]}
   */
  get rewardPatterns() {
    return this._rewardPatterns;
  }
  addRewardPatterns(path, value) {
    return {type: 'ADD', path: path.concat(['rewardPatterns']), value};
  }
  setRewardPatterns(path, value) {
    return {type: 'SET', path: path.concat(['rewardPatterns']), value: ArrayToJson(value, JsonToString)};
  }
  setRewardPatternsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewardPatterns', key]), value};
  }
  deleteRewardPatterns(path) {
    return {type: 'DELETE', path: path.concat(['rewardPatterns'])};
  }
  deleteRewardPatternsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewardPatterns', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "requiredPoints": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestActivePointChest(this);
              copy._hasRequiredPoints = true;
              copy._requiredPoints = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRequiredPoints) {
                return this;
              }
              const copy = new QuestActivePointChest(this);
              copy._hasRequiredPoints = false;
              copy._requiredPoints = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "rewardPatterns": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestActivePointChest(this);
              copy._rewardPatterns = [];        for (let i of value) {
                copy._rewardPatterns.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new QuestActivePointChest(this);
              copy._rewardPatterns = copy._rewardPatterns.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewardPatterns.length === 0) {
                return this;
              }
              const copy = new QuestActivePointChest(this);
              copy._rewardPatterns = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewardPatterns.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new QuestActivePointChest(this);
              copy._rewardPatterns = copy._rewardPatterns.slice();
              copy._rewardPatterns[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new QuestActivePointChest(this);
              copy._rewardPatterns = copy._rewardPatterns.slice(0, path[1]).concat(copy._rewardPatterns.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewardPatterns.length) {
            return this;
          }
          const oldValue = this._rewardPatterns[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new QuestActivePointChest(this);
          copy._rewardPatterns = copy._rewardPatterns.slice();
          copy._rewardPatterns[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {QuestActivePointChest} other
   * @returns {QuestActivePointChest}
   */
  merge(other) {
    const copy = new QuestActivePointChest(this);
    if (other._hasRequiredPoints) {
      copy._hasRequiredPoints = true;
      copy._requiredPoints = other._requiredPoints;
    }
    copy._rewardPatterns = this._rewardPatterns.concat(other._rewardPatterns);
    return copy;
  }
}
QuestActivePointChest.default = new QuestActivePointChest();
class QuestActivePointChest_Builder {
  constructor(value) {
    this._value = new QuestActivePointChest(value);
  }
  build() {
    return new QuestActivePointChest(this._value);
  }
  setRequiredPoints(value) {
    this._value._hasRequiredPoints = true;
    this._value._requiredPoints = value;
    return this;
  }
  deleteRequiredPoints() {
    this._value._hasRequiredPoints = false;
    this._value._requiredPoints = null;
    return this;
  }
  addAllRewardPatterns(values) {
    this._value._rewardPatterns = this._value._rewardPatterns.concat(values);
    return this;
  }
  addRewardPatterns(value) {
    this._value._rewardPatterns = this._value._rewardPatterns.concat([value]);
    return this;
  }
  setRewardPatterns(index, value) {
    this._value._rewardPatterns = this._value._rewardPatterns.concat();
    this._value._rewardPatterns[index] = value;
    return this;
  }
  clearRewardPatterns() {
    this._value._rewardPatterns = [];
    return this;
  }
}
QuestActivePointChest.Builder = QuestActivePointChest_Builder;
class QuestActivePointChest_WithParent {
  /**
   * @param {QuestActivePointChest} value
   * @param {QuestActivePointChest_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return QuestActivePointChest.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasRequiredPoints() {
    if (this._cachedHasRequiredPoints === undefined) {
      if (this._value.hasRequiredPoints) {
        this._cachedHasRequiredPoints = true;
      } else {
        this._cachedHasRequiredPoints = this._parent ? this._parent.hasRequiredPoints : false;
      }
    }
    return this._cachedHasRequiredPoints;
  }
  get requiredPoints() {
    if (this._cachedRequiredPoints === undefined) {
      if (this._value.hasRequiredPoints) {
        this._cachedRequiredPoints = this._value.requiredPoints;
      } else {
        this._cachedRequiredPoints = this._parent ? this._parent.requiredPoints : this._value.requiredPoints;
      }
    }
    return this._cachedRequiredPoints;
  }
  get selfRewardPatterns() {
    return this._value.rewardPatterns;
  }
  get inherentRewardPatterns() {
    if (!this._inherentRewardPatterns) {
      this._inherentRewardPatterns = this._parent ? this._parent.rewardPatterns : [];
    }
    return this._inherentRewardPatterns;
  }
  get rewardPatterns() {
    if (!this._allRewardPatterns) {
      this._allRewardPatterns = this._parent ? this._parent.rewardPatterns.concat(this.selfRewardPatterns) : this.selfRewardPatterns;
    }
    return this._allRewardPatterns;
  }
  update(current, parent) {
    const result = new QuestActivePointChest_WithParent(current, parent);
    return result;
  }
}
QuestActivePointChest_WithParent.default = new QuestActivePointChest_WithParent(QuestActivePointChest.default, null);
QuestActivePointChest.WithParent = QuestActivePointChest_WithParent;
class QuestActivePointChest_Descriptor {
  get requiredPoints() {
    if (!this._requiredPoints) {
      this._requiredPoints = {
        name: "requiredPoints",
        Name: "RequiredPoints",
        number: 1,
        protoType: 5,
        protoName: "required_points",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._requiredPoints;
  }
  get rewardPatterns() {
    if (!this._rewardPatterns) {
      this._rewardPatterns = {
        name: "rewardPatterns",
        Name: "RewardPatterns",
        number: 11,
        protoType: 9,
        protoName: "reward_patterns",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "RewardPatternNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewardPatterns;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.requiredPoints,
        this.rewardPatterns,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForRequiredPoints",
        Name: "DummyOneofForRequiredPoints",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
QuestActivePointChest.descriptor = new QuestActivePointChest_Descriptor();
class QuestDefinition_ProgressedReward {
  get descriptor() {
    return QuestDefinition_ProgressedReward.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasProgress = false;
    this._progress = null;
    this._rewardItems = [];
  }
  isEmpty() {
    if (this._hasProgress) return false;
    if (this._rewardItems.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof QuestDefinition_ProgressedReward) {
      return value;
    }
    return QuestDefinition_ProgressedReward.fromJson(value);
  }
  static fromJson(json) {
    const result = new QuestDefinition_ProgressedReward();
    if (json.progress != null) {
      result._hasProgress = true;
      result._progress = JsonToInt32.fromJson(json.progress);
    }
    result._rewardItems = JsonToList(json.rewardItems, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasProgress) {
      result.progress = JsonToInt32.toJson(this._progress);
    }
    if (this._rewardItems.length > 0) {
      result.rewardItems = ArrayToJson(this._rewardItems, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get progress() {
    return this._hasProgress ? this._progress : JsonToInt32.default;
  }
  get hasProgress() {
    return this._hasProgress;
  }
  setProgress(path, value) {
    return {type: 'SET', path: path.concat(['progress']), value};
  }
  deleteProgress(path) {
    return {type: 'DELETE', path: path.concat(['progress'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get rewardItems() {
    return this._rewardItems;
  }
  addRewardItems(path, value) {
    return {type: 'ADD', path: path.concat(['rewardItems']), value: value.toJson()};
  }
  setRewardItems(path, value) {
    return {type: 'SET', path: path.concat(['rewardItems']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setRewardItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewardItems', key]), value: value.toJson()};
  }
  deleteRewardItems(path) {
    return {type: 'DELETE', path: path.concat(['rewardItems'])};
  }
  deleteRewardItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewardItems', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "progress": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition_ProgressedReward(this);
              copy._hasProgress = true;
              copy._progress = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasProgress) {
                return this;
              }
              const copy = new QuestDefinition_ProgressedReward(this);
              copy._hasProgress = false;
              copy._progress = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "rewardItems": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition_ProgressedReward(this);
              copy._rewardItems = [];        for (let i of value) {
                copy._rewardItems.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new QuestDefinition_ProgressedReward(this);
              copy._rewardItems = copy._rewardItems.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewardItems.length === 0) {
                return this;
              }
              const copy = new QuestDefinition_ProgressedReward(this);
              copy._rewardItems = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewardItems.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition_ProgressedReward(this);
              copy._rewardItems = copy._rewardItems.slice();
              copy._rewardItems[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new QuestDefinition_ProgressedReward(this);
              copy._rewardItems = copy._rewardItems.slice(0, path[1]).concat(copy._rewardItems.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewardItems.length) {
            return this;
          }
          const oldValue = this._rewardItems[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new QuestDefinition_ProgressedReward(this);
          copy._rewardItems = copy._rewardItems.slice();
          copy._rewardItems[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {QuestDefinition_ProgressedReward} other
   * @returns {QuestDefinition_ProgressedReward}
   */
  merge(other) {
    const copy = new QuestDefinition_ProgressedReward(this);
    if (other._hasProgress) {
      copy._hasProgress = true;
      copy._progress = other._progress;
    }
    copy._rewardItems = this._rewardItems.concat(other._rewardItems);
    return copy;
  }
}
QuestDefinition_ProgressedReward.default = new QuestDefinition_ProgressedReward();
class QuestDefinition_ProgressedReward_Builder {
  constructor(value) {
    this._value = new QuestDefinition_ProgressedReward(value);
  }
  build() {
    return new QuestDefinition_ProgressedReward(this._value);
  }
  setProgress(value) {
    this._value._hasProgress = true;
    this._value._progress = value;
    return this;
  }
  deleteProgress() {
    this._value._hasProgress = false;
    this._value._progress = null;
    return this;
  }
  addAllRewardItems(values) {
    this._value._rewardItems = this._value._rewardItems.concat(values);
    return this;
  }
  addRewardItems(value) {
    this._value._rewardItems = this._value._rewardItems.concat([value]);
    return this;
  }
  setRewardItems(index, value) {
    this._value._rewardItems = this._value._rewardItems.concat();
    this._value._rewardItems[index] = value;
    return this;
  }
  clearRewardItems() {
    this._value._rewardItems = [];
    return this;
  }
}
QuestDefinition_ProgressedReward.Builder = QuestDefinition_ProgressedReward_Builder;
class QuestDefinition_ProgressedReward_WithParent {
  /**
   * @param {QuestDefinition_ProgressedReward} value
   * @param {QuestDefinition_ProgressedReward_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return QuestDefinition_ProgressedReward.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasProgress() {
    if (this._cachedHasProgress === undefined) {
      if (this._value.hasProgress) {
        this._cachedHasProgress = true;
      } else {
        this._cachedHasProgress = this._parent ? this._parent.hasProgress : false;
      }
    }
    return this._cachedHasProgress;
  }
  get progress() {
    if (this._cachedProgress === undefined) {
      if (this._value.hasProgress) {
        this._cachedProgress = this._value.progress;
      } else {
        this._cachedProgress = this._parent ? this._parent.progress : this._value.progress;
      }
    }
    return this._cachedProgress;
  }
  get selfRewardItems() {
    if (!this._selfRewardItems) {
      this._selfRewardItems = [];
      for (let i of this._value.rewardItems) {
        this._selfRewardItems.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfRewardItems;
  }
  get inherentRewardItems() {
    if (!this._inherentRewardItems) {
      this._inherentRewardItems = this._parent ? this._parent.rewardItems : [];
    }
    return this._inherentRewardItems;
  }
  get rewardItems() {
    if (!this._allRewardItems) {
      this._allRewardItems = this._parent ? this._parent.rewardItems.concat(this.selfRewardItems) : this.selfRewardItems;
    }
    return this._allRewardItems;
  }
  update(current, parent) {
    const result = new QuestDefinition_ProgressedReward_WithParent(current, parent);
    if (this._selfRewardItems) {
      if (this._value.rewardItems === current.rewardItems) {
        result._selfRewardItems = this._selfRewardItems;
      } else {
        result._selfRewardItems = [];
        for (let i = 0; i < current.rewardItems.length; i++) {
          const oldValue = this._value.rewardItems[i];
          if (oldValue) {
            const oldCache = this._selfRewardItems[i];
            if (oldValue === current.rewardItems[i]) {
              result._selfRewardItems[i] = oldCache;
            } else {
              result._selfRewardItems[i] = oldCache.update(current.rewardItems[i], null);
            }
          } else {
            result._selfRewardItems[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.rewardItems[i], null);
          }
        }
      }
    }
    return result;
  }
}
QuestDefinition_ProgressedReward_WithParent.default = new QuestDefinition_ProgressedReward_WithParent(QuestDefinition_ProgressedReward.default, null);
QuestDefinition_ProgressedReward.WithParent = QuestDefinition_ProgressedReward_WithParent;
class QuestDefinition_ProgressedReward_Descriptor {
  get progress() {
    if (!this._progress) {
      this._progress = {
        name: "progress",
        Name: "Progress",
        number: 1,
        protoType: 5,
        protoName: "progress",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._progress;
  }
  get rewardItems() {
    if (!this._rewardItems) {
      this._rewardItems = {
        name: "rewardItems",
        Name: "RewardItems",
        number: 2,
        protoType: 11,
        protoName: "reward_items",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewardItems;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.progress,
        this.rewardItems,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForProgress",
        Name: "DummyOneofForProgress",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
QuestDefinition_ProgressedReward.descriptor = new QuestDefinition_ProgressedReward_Descriptor();
class QuestDefinition_ProgressSyncType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "EVENT": return 0;
        case "ELEMENTAL_TRIAL_COMPLETE": return 1;
        case "ELEMENTAL_TRIAL_COMPLETE_ACCUMULATED": return 2;
        case "MINE_FLOOR": return 3;
        case "WEEKLY_QUEST_POINT_ACCUMULATED": return 4;
        case "HERO_LEVEL_UP_ACCUMULATED": return 5;
        case "HERO_SKILL_LEVEL_UP_ACCUMULATED": return 6;
        case "MARKET_PURCHASE_ACCUMULATED": return 7;
        case "OPEN_NORMAL_EVENT_CHEST_ACCUMULATED": return 8;
        case "OPEN_PREMIUM_CHEST_ACCUMULATED": return 9;
        case "EVENT_SOLO_LEVEL_BEAT_ACCUMULATED": return 10;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return QuestDefinition_ProgressSyncType.fromJson(value);
  }
  static fromReact(e) {
    return QuestDefinition_ProgressSyncType.fromJson(e);
  }
}
QuestDefinition_ProgressSyncType.EVENT = 0;
QuestDefinition_ProgressSyncType.ELEMENTAL_TRIAL_COMPLETE = 1;
QuestDefinition_ProgressSyncType.ELEMENTAL_TRIAL_COMPLETE_ACCUMULATED = 2;
QuestDefinition_ProgressSyncType.MINE_FLOOR = 3;
QuestDefinition_ProgressSyncType.WEEKLY_QUEST_POINT_ACCUMULATED = 4;
QuestDefinition_ProgressSyncType.HERO_LEVEL_UP_ACCUMULATED = 5;
QuestDefinition_ProgressSyncType.HERO_SKILL_LEVEL_UP_ACCUMULATED = 6;
QuestDefinition_ProgressSyncType.MARKET_PURCHASE_ACCUMULATED = 7;
QuestDefinition_ProgressSyncType.OPEN_NORMAL_EVENT_CHEST_ACCUMULATED = 8;
QuestDefinition_ProgressSyncType.OPEN_PREMIUM_CHEST_ACCUMULATED = 9;
QuestDefinition_ProgressSyncType.EVENT_SOLO_LEVEL_BEAT_ACCUMULATED = 10;
QuestDefinition_ProgressSyncType.default = 0;
QuestDefinition_ProgressSyncType.values = {
  EVENT: 0,
  ELEMENTAL_TRIAL_COMPLETE: 1,
  ELEMENTAL_TRIAL_COMPLETE_ACCUMULATED: 2,
  MINE_FLOOR: 3,
  WEEKLY_QUEST_POINT_ACCUMULATED: 4,
  HERO_LEVEL_UP_ACCUMULATED: 5,
  HERO_SKILL_LEVEL_UP_ACCUMULATED: 6,
  MARKET_PURCHASE_ACCUMULATED: 7,
  OPEN_NORMAL_EVENT_CHEST_ACCUMULATED: 8,
  OPEN_PREMIUM_CHEST_ACCUMULATED: 9,
  EVENT_SOLO_LEVEL_BEAT_ACCUMULATED: 10,
};
QuestDefinition_ProgressSyncType.names = {
  0: "EVENT",
  1: "ELEMENTAL_TRIAL_COMPLETE",
  2: "ELEMENTAL_TRIAL_COMPLETE_ACCUMULATED",
  3: "MINE_FLOOR",
  4: "WEEKLY_QUEST_POINT_ACCUMULATED",
  5: "HERO_LEVEL_UP_ACCUMULATED",
  6: "HERO_SKILL_LEVEL_UP_ACCUMULATED",
  7: "MARKET_PURCHASE_ACCUMULATED",
  8: "OPEN_NORMAL_EVENT_CHEST_ACCUMULATED",
  9: "OPEN_PREMIUM_CHEST_ACCUMULATED",
  10: "EVENT_SOLO_LEVEL_BEAT_ACCUMULATED",
};
export class QuestDefinition {
  get descriptor() {
    return QuestDefinition.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasDescription = false;
    this._description = null;
    this._hasStartProgress = false;
    this._startProgress = null;
    this._hasProgressTotal = false;
    this._progressTotal = null;
    this._hasEvent = false;
    this._event = null;
    this._hasPresentIfRewarded = false;
    this._presentIfRewarded = null;
    this._hasFilter = false;
    this._filter = null;
    this._openDays = [];
    this._rewardItems = [];
    this._eventAttributes = [];
    this._hasNavigationEntry = false;
    this._navigationEntry = null;
    this._hasActivePointsReward = false;
    this._activePointsReward = null;
    this._hasProgressSyncType = false;
    this._progressSyncType = null;
    this._progressRewards = [];
    this._hasDependentSystem = false;
    this._dependentSystem = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasDescription) return false;
    if (this._hasStartProgress) return false;
    if (this._hasProgressTotal) return false;
    if (this._hasEvent) return false;
    if (this._hasPresentIfRewarded) return false;
    if (this._hasFilter && !this._filter.isEmpty()) return false;
    if (this._openDays.length > 0) return false;
    if (this._rewardItems.length > 0) return false;
    if (this._eventAttributes.length > 0) return false;
    if (this._hasNavigationEntry && !this._navigationEntry.isEmpty()) return false;
    if (this._hasActivePointsReward) return false;
    if (this._hasProgressSyncType) return false;
    if (this._progressRewards.length > 0) return false;
    if (this._hasDependentSystem) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof QuestDefinition) {
      return value;
    }
    return QuestDefinition.fromJson(value);
  }
  static fromJson(json) {
    const result = new QuestDefinition();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.description != null) {
      result._hasDescription = true;
      result._description = JsonToString.fromJson(json.description);
    }
    if (json.startProgress != null) {
      result._hasStartProgress = true;
      result._startProgress = JsonToInt32.fromJson(json.startProgress);
    }
    if (json.progressTotal != null) {
      result._hasProgressTotal = true;
      result._progressTotal = JsonToInt32.fromJson(json.progressTotal);
    }
    if (json.event != null) {
      result._hasEvent = true;
      result._event = JsonToString.fromJson(json.event);
    }
    if (json.presentIfRewarded != null) {
      result._hasPresentIfRewarded = true;
      result._presentIfRewarded = JsonToBoolean.fromJson(json.presentIfRewarded);
    }
    if (json.filter != null) {
      result._hasFilter = true;
      result._filter = Filter.fromJson(json.filter);
    }
    result._openDays = JsonToList(json.openDays, JsonToString);
    result._rewardItems = JsonToList(json.rewardItems, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    result._eventAttributes = JsonToList(json.eventAttributes, dcei_wildsky_common_proto.StringStringPair);
    if (json.navigationEntry != null) {
      result._hasNavigationEntry = true;
      result._navigationEntry = dcei_wildsky_common_proto.PageNavigationEntry.fromJson(json.navigationEntry);
    }
    if (json.activePointsReward != null) {
      result._hasActivePointsReward = true;
      result._activePointsReward = JsonToInt32.fromJson(json.activePointsReward);
    }
    if (json.progressSyncType != null) {
      result._hasProgressSyncType = true;
      result._progressSyncType = QuestDefinition_ProgressSyncType.fromJson(json.progressSyncType);
    }
    result._progressRewards = JsonToList(json.progressRewards, QuestDefinition_ProgressedReward);
    if (json.dependentSystem != null) {
      result._hasDependentSystem = true;
      result._dependentSystem = JsonToString.fromJson(json.dependentSystem);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasDescription) {
      result.description = JsonToString.toJson(this._description);
    }
    if (this._hasStartProgress) {
      result.startProgress = JsonToInt32.toJson(this._startProgress);
    }
    if (this._hasProgressTotal) {
      result.progressTotal = JsonToInt32.toJson(this._progressTotal);
    }
    if (this._hasEvent) {
      result.event = JsonToString.toJson(this._event);
    }
    if (this._hasPresentIfRewarded) {
      result.presentIfRewarded = JsonToBoolean.toJson(this._presentIfRewarded);
    }
    if (this._hasFilter && !this._filter.isEmpty()) {
      result.filter = Filter.toJson(this._filter);
    }
    if (this._openDays.length > 0) {
      result.openDays = ArrayToJson(this._openDays, JsonToString);
    }
    if (this._rewardItems.length > 0) {
      result.rewardItems = ArrayToJson(this._rewardItems, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    if (this._eventAttributes.length > 0) {
      result.eventAttributes = ArrayToJson(this._eventAttributes, dcei_wildsky_common_proto.StringStringPair);
    }
    if (this._hasNavigationEntry && !this._navigationEntry.isEmpty()) {
      result.navigationEntry = dcei_wildsky_common_proto.PageNavigationEntry.toJson(this._navigationEntry);
    }
    if (this._hasActivePointsReward) {
      result.activePointsReward = JsonToInt32.toJson(this._activePointsReward);
    }
    if (this._hasProgressSyncType) {
      result.progressSyncType = QuestDefinition_ProgressSyncType.toJson(this._progressSyncType);
    }
    if (this._progressRewards.length > 0) {
      result.progressRewards = ArrayToJson(this._progressRewards, QuestDefinition_ProgressedReward);
    }
    if (this._hasDependentSystem) {
      result.dependentSystem = JsonToString.toJson(this._dependentSystem);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {string}
   */
  get description() {
    return this._hasDescription ? this._description : JsonToString.default;
  }
  get hasDescription() {
    return this._hasDescription;
  }
  setDescription(path, value) {
    return {type: 'SET', path: path.concat(['description']), value};
  }
  deleteDescription(path) {
    return {type: 'DELETE', path: path.concat(['description'])};
  }
  /**
   * @returns {number}
   */
  get startProgress() {
    return this._hasStartProgress ? this._startProgress : JsonToInt32.default;
  }
  get hasStartProgress() {
    return this._hasStartProgress;
  }
  setStartProgress(path, value) {
    return {type: 'SET', path: path.concat(['startProgress']), value};
  }
  deleteStartProgress(path) {
    return {type: 'DELETE', path: path.concat(['startProgress'])};
  }
  /**
   * @returns {number}
   */
  get progressTotal() {
    return this._hasProgressTotal ? this._progressTotal : JsonToInt32.default;
  }
  get hasProgressTotal() {
    return this._hasProgressTotal;
  }
  setProgressTotal(path, value) {
    return {type: 'SET', path: path.concat(['progressTotal']), value};
  }
  deleteProgressTotal(path) {
    return {type: 'DELETE', path: path.concat(['progressTotal'])};
  }
  /**
   * @returns {string}
   */
  get event() {
    return this._hasEvent ? this._event : JsonToString.default;
  }
  get hasEvent() {
    return this._hasEvent;
  }
  setEvent(path, value) {
    return {type: 'SET', path: path.concat(['event']), value};
  }
  deleteEvent(path) {
    return {type: 'DELETE', path: path.concat(['event'])};
  }
  /**
   * @returns {boolean}
   */
  get presentIfRewarded() {
    return this._hasPresentIfRewarded ? this._presentIfRewarded : JsonToBoolean.default;
  }
  get hasPresentIfRewarded() {
    return this._hasPresentIfRewarded;
  }
  setPresentIfRewarded(path, value) {
    return {type: 'SET', path: path.concat(['presentIfRewarded']), value};
  }
  deletePresentIfRewarded(path) {
    return {type: 'DELETE', path: path.concat(['presentIfRewarded'])};
  }
  /**
   * @returns {Filter}
   */
  get filter() {
    return this._hasFilter ? this._filter : Filter.default;
  }
  get hasFilter() {
    return this._hasFilter;
  }
  setFilter(path, value) {
    return {type: 'SET', path: path.concat(['filter']), value: value.toJson()};
  }
  deleteFilter(path) {
    return {type: 'DELETE', path: path.concat(['filter'])};
  }
  /**
   * @returns {string[]}
   */
  get openDays() {
    return this._openDays;
  }
  addOpenDays(path, value) {
    return {type: 'ADD', path: path.concat(['openDays']), value};
  }
  setOpenDays(path, value) {
    return {type: 'SET', path: path.concat(['openDays']), value: ArrayToJson(value, JsonToString)};
  }
  setOpenDaysByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['openDays', key]), value};
  }
  deleteOpenDays(path) {
    return {type: 'DELETE', path: path.concat(['openDays'])};
  }
  deleteOpenDaysByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['openDays', key])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get rewardItems() {
    return this._rewardItems;
  }
  addRewardItems(path, value) {
    return {type: 'ADD', path: path.concat(['rewardItems']), value: value.toJson()};
  }
  setRewardItems(path, value) {
    return {type: 'SET', path: path.concat(['rewardItems']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setRewardItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewardItems', key]), value: value.toJson()};
  }
  deleteRewardItems(path) {
    return {type: 'DELETE', path: path.concat(['rewardItems'])};
  }
  deleteRewardItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewardItems', key])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.StringStringPair[]}
   */
  get eventAttributes() {
    return this._eventAttributes;
  }
  addEventAttributes(path, value) {
    return {type: 'ADD', path: path.concat(['eventAttributes']), value: value.toJson()};
  }
  setEventAttributes(path, value) {
    return {type: 'SET', path: path.concat(['eventAttributes']), value: ArrayToJson(value, dcei_wildsky_common_proto.StringStringPair)};
  }
  setEventAttributesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['eventAttributes', key]), value: value.toJson()};
  }
  deleteEventAttributes(path) {
    return {type: 'DELETE', path: path.concat(['eventAttributes'])};
  }
  deleteEventAttributesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['eventAttributes', key])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.PageNavigationEntry}
   */
  get navigationEntry() {
    return this._hasNavigationEntry ? this._navigationEntry : dcei_wildsky_common_proto.PageNavigationEntry.default;
  }
  get hasNavigationEntry() {
    return this._hasNavigationEntry;
  }
  setNavigationEntry(path, value) {
    return {type: 'SET', path: path.concat(['navigationEntry']), value: value.toJson()};
  }
  deleteNavigationEntry(path) {
    return {type: 'DELETE', path: path.concat(['navigationEntry'])};
  }
  /**
   * @returns {number}
   */
  get activePointsReward() {
    return this._hasActivePointsReward ? this._activePointsReward : JsonToInt32.default;
  }
  get hasActivePointsReward() {
    return this._hasActivePointsReward;
  }
  setActivePointsReward(path, value) {
    return {type: 'SET', path: path.concat(['activePointsReward']), value};
  }
  deleteActivePointsReward(path) {
    return {type: 'DELETE', path: path.concat(['activePointsReward'])};
  }
  /**
   * @returns {number}
   */
  get progressSyncType() {
    return this._hasProgressSyncType ? this._progressSyncType : QuestDefinition_ProgressSyncType.default;
  }
  get hasProgressSyncType() {
    return this._hasProgressSyncType;
  }
  setProgressSyncType(path, value) {
    return {type: 'SET', path: path.concat(['progressSyncType']), value};
  }
  deleteProgressSyncType(path) {
    return {type: 'DELETE', path: path.concat(['progressSyncType'])};
  }
  /**
   * @returns {QuestDefinition_ProgressedReward[]}
   */
  get progressRewards() {
    return this._progressRewards;
  }
  addProgressRewards(path, value) {
    return {type: 'ADD', path: path.concat(['progressRewards']), value: value.toJson()};
  }
  setProgressRewards(path, value) {
    return {type: 'SET', path: path.concat(['progressRewards']), value: ArrayToJson(value, QuestDefinition_ProgressedReward)};
  }
  setProgressRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['progressRewards', key]), value: value.toJson()};
  }
  deleteProgressRewards(path) {
    return {type: 'DELETE', path: path.concat(['progressRewards'])};
  }
  deleteProgressRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['progressRewards', key])};
  }
  /**
   * @returns {string}
   */
  get dependentSystem() {
    return this._hasDependentSystem ? this._dependentSystem : JsonToString.default;
  }
  get hasDependentSystem() {
    return this._hasDependentSystem;
  }
  setDependentSystem(path, value) {
    return {type: 'SET', path: path.concat(['dependentSystem']), value};
  }
  deleteDependentSystem(path) {
    return {type: 'DELETE', path: path.concat(['dependentSystem'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new QuestDefinition(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "description": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition(this);
              copy._hasDescription = true;
              copy._description = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDescription) {
                return this;
              }
              const copy = new QuestDefinition(this);
              copy._hasDescription = false;
              copy._description = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "startProgress": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition(this);
              copy._hasStartProgress = true;
              copy._startProgress = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartProgress) {
                return this;
              }
              const copy = new QuestDefinition(this);
              copy._hasStartProgress = false;
              copy._startProgress = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "progressTotal": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition(this);
              copy._hasProgressTotal = true;
              copy._progressTotal = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasProgressTotal) {
                return this;
              }
              const copy = new QuestDefinition(this);
              copy._hasProgressTotal = false;
              copy._progressTotal = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "event": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition(this);
              copy._hasEvent = true;
              copy._event = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEvent) {
                return this;
              }
              const copy = new QuestDefinition(this);
              copy._hasEvent = false;
              copy._event = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "presentIfRewarded": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition(this);
              copy._hasPresentIfRewarded = true;
              copy._presentIfRewarded = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPresentIfRewarded) {
                return this;
              }
              const copy = new QuestDefinition(this);
              copy._hasPresentIfRewarded = false;
              copy._presentIfRewarded = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "filter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition(this);
              copy._hasFilter = true;
              copy._filter = Filter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFilter) {
                return this;
              }
              const copy = new QuestDefinition(this);
              copy._hasFilter = false;
              copy._filter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasFilter) {
            const copy = new QuestDefinition(this);
            copy._hasFilter = true;
            copy._filter = Filter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._filter.apply(type, path.slice(1), value);
          if (newValue === this._filter) {
            return this;
          }
          const copy = new QuestDefinition(this);
          copy._filter = copy._filter.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "openDays": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition(this);
              copy._openDays = [];        for (let i of value) {
                copy._openDays.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new QuestDefinition(this);
              copy._openDays = copy._openDays.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._openDays.length === 0) {
                return this;
              }
              const copy = new QuestDefinition(this);
              copy._openDays = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._openDays.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition(this);
              copy._openDays = copy._openDays.slice();
              copy._openDays[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new QuestDefinition(this);
              copy._openDays = copy._openDays.slice(0, path[1]).concat(copy._openDays.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._openDays.length) {
            return this;
          }
          const oldValue = this._openDays[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new QuestDefinition(this);
          copy._openDays = copy._openDays.slice();
          copy._openDays[key] = newValue;
          return copy;
        }
      }
      case "rewardItems": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition(this);
              copy._rewardItems = [];        for (let i of value) {
                copy._rewardItems.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new QuestDefinition(this);
              copy._rewardItems = copy._rewardItems.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewardItems.length === 0) {
                return this;
              }
              const copy = new QuestDefinition(this);
              copy._rewardItems = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewardItems.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition(this);
              copy._rewardItems = copy._rewardItems.slice();
              copy._rewardItems[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new QuestDefinition(this);
              copy._rewardItems = copy._rewardItems.slice(0, path[1]).concat(copy._rewardItems.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewardItems.length) {
            return this;
          }
          const oldValue = this._rewardItems[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new QuestDefinition(this);
          copy._rewardItems = copy._rewardItems.slice();
          copy._rewardItems[key] = newValue;
          return copy;
        }
      }
      case "eventAttributes": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition(this);
              copy._eventAttributes = [];        for (let i of value) {
                copy._eventAttributes.push(dcei_wildsky_common_proto.StringStringPair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new QuestDefinition(this);
              copy._eventAttributes = copy._eventAttributes.concat([dcei_wildsky_common_proto.StringStringPair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._eventAttributes.length === 0) {
                return this;
              }
              const copy = new QuestDefinition(this);
              copy._eventAttributes = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._eventAttributes.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition(this);
              copy._eventAttributes = copy._eventAttributes.slice();
              copy._eventAttributes[path[1]] = dcei_wildsky_common_proto.StringStringPair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new QuestDefinition(this);
              copy._eventAttributes = copy._eventAttributes.slice(0, path[1]).concat(copy._eventAttributes.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._eventAttributes.length) {
            return this;
          }
          const oldValue = this._eventAttributes[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new QuestDefinition(this);
          copy._eventAttributes = copy._eventAttributes.slice();
          copy._eventAttributes[key] = newValue;
          return copy;
        }
      }
      case "navigationEntry": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition(this);
              copy._hasNavigationEntry = true;
              copy._navigationEntry = dcei_wildsky_common_proto.PageNavigationEntry.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNavigationEntry) {
                return this;
              }
              const copy = new QuestDefinition(this);
              copy._hasNavigationEntry = false;
              copy._navigationEntry = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasNavigationEntry) {
            const copy = new QuestDefinition(this);
            copy._hasNavigationEntry = true;
            copy._navigationEntry = dcei_wildsky_common_proto.PageNavigationEntry.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._navigationEntry.apply(type, path.slice(1), value);
          if (newValue === this._navigationEntry) {
            return this;
          }
          const copy = new QuestDefinition(this);
          copy._navigationEntry = copy._navigationEntry.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "activePointsReward": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition(this);
              copy._hasActivePointsReward = true;
              copy._activePointsReward = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActivePointsReward) {
                return this;
              }
              const copy = new QuestDefinition(this);
              copy._hasActivePointsReward = false;
              copy._activePointsReward = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "progressSyncType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition(this);
              copy._hasProgressSyncType = true;
              copy._progressSyncType = QuestDefinition_ProgressSyncType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasProgressSyncType) {
                return this;
              }
              const copy = new QuestDefinition(this);
              copy._hasProgressSyncType = false;
              copy._progressSyncType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "progressRewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition(this);
              copy._progressRewards = [];        for (let i of value) {
                copy._progressRewards.push(QuestDefinition_ProgressedReward.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new QuestDefinition(this);
              copy._progressRewards = copy._progressRewards.concat([QuestDefinition_ProgressedReward.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._progressRewards.length === 0) {
                return this;
              }
              const copy = new QuestDefinition(this);
              copy._progressRewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._progressRewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition(this);
              copy._progressRewards = copy._progressRewards.slice();
              copy._progressRewards[path[1]] = QuestDefinition_ProgressedReward.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new QuestDefinition(this);
              copy._progressRewards = copy._progressRewards.slice(0, path[1]).concat(copy._progressRewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._progressRewards.length) {
            return this;
          }
          const oldValue = this._progressRewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new QuestDefinition(this);
          copy._progressRewards = copy._progressRewards.slice();
          copy._progressRewards[key] = newValue;
          return copy;
        }
      }
      case "dependentSystem": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestDefinition(this);
              copy._hasDependentSystem = true;
              copy._dependentSystem = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDependentSystem) {
                return this;
              }
              const copy = new QuestDefinition(this);
              copy._hasDependentSystem = false;
              copy._dependentSystem = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {QuestDefinition} other
   * @returns {QuestDefinition}
   */
  merge(other) {
    const copy = new QuestDefinition(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasDescription) {
      copy._hasDescription = true;
      copy._description = other._description;
    }
    if (other._hasStartProgress) {
      copy._hasStartProgress = true;
      copy._startProgress = other._startProgress;
    }
    if (other._hasProgressTotal) {
      copy._hasProgressTotal = true;
      copy._progressTotal = other._progressTotal;
    }
    if (other._hasEvent) {
      copy._hasEvent = true;
      copy._event = other._event;
    }
    if (other._hasPresentIfRewarded) {
      copy._hasPresentIfRewarded = true;
      copy._presentIfRewarded = other._presentIfRewarded;
    }
    if (other._hasFilter) {
      if (copy._hasFilter) {
        copy._filter = copy.filter.merge(other.filter);
      } else {
        copy._filter = other._filter;
      }
      copy._hasFilter = true;
    }
    copy._openDays = this._openDays.concat(other._openDays);
    copy._rewardItems = this._rewardItems.concat(other._rewardItems);
    copy._eventAttributes = this._eventAttributes.concat(other._eventAttributes);
    if (other._hasNavigationEntry) {
      if (copy._hasNavigationEntry) {
        copy._navigationEntry = copy.navigationEntry.merge(other.navigationEntry);
      } else {
        copy._navigationEntry = other._navigationEntry;
      }
      copy._hasNavigationEntry = true;
    }
    if (other._hasActivePointsReward) {
      copy._hasActivePointsReward = true;
      copy._activePointsReward = other._activePointsReward;
    }
    if (other._hasProgressSyncType) {
      copy._hasProgressSyncType = true;
      copy._progressSyncType = other._progressSyncType;
    }
    copy._progressRewards = this._progressRewards.concat(other._progressRewards);
    if (other._hasDependentSystem) {
      copy._hasDependentSystem = true;
      copy._dependentSystem = other._dependentSystem;
    }
    return copy;
  }
}
QuestDefinition.default = new QuestDefinition();
QuestDefinition.ProgressedReward = QuestDefinition_ProgressedReward;
QuestDefinition.ProgressSyncType = QuestDefinition_ProgressSyncType;
class QuestDefinition_Builder {
  constructor(value) {
    this._value = new QuestDefinition(value);
  }
  build() {
    return new QuestDefinition(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setDescription(value) {
    this._value._hasDescription = true;
    this._value._description = value;
    return this;
  }
  deleteDescription() {
    this._value._hasDescription = false;
    this._value._description = null;
    return this;
  }
  setStartProgress(value) {
    this._value._hasStartProgress = true;
    this._value._startProgress = value;
    return this;
  }
  deleteStartProgress() {
    this._value._hasStartProgress = false;
    this._value._startProgress = null;
    return this;
  }
  setProgressTotal(value) {
    this._value._hasProgressTotal = true;
    this._value._progressTotal = value;
    return this;
  }
  deleteProgressTotal() {
    this._value._hasProgressTotal = false;
    this._value._progressTotal = null;
    return this;
  }
  setEvent(value) {
    this._value._hasEvent = true;
    this._value._event = value;
    return this;
  }
  deleteEvent() {
    this._value._hasEvent = false;
    this._value._event = null;
    return this;
  }
  setPresentIfRewarded(value) {
    this._value._hasPresentIfRewarded = true;
    this._value._presentIfRewarded = value;
    return this;
  }
  deletePresentIfRewarded() {
    this._value._hasPresentIfRewarded = false;
    this._value._presentIfRewarded = null;
    return this;
  }
  setFilter(value) {
    this._value._hasFilter = true;
    this._value._filter = value;
    return this;
  }
  deleteFilter() {
    this._value._hasFilter = false;
    this._value._filter = null;
    return this;
  }
  addAllOpenDays(values) {
    this._value._openDays = this._value._openDays.concat(values);
    return this;
  }
  addOpenDays(value) {
    this._value._openDays = this._value._openDays.concat([value]);
    return this;
  }
  setOpenDays(index, value) {
    this._value._openDays = this._value._openDays.concat();
    this._value._openDays[index] = value;
    return this;
  }
  clearOpenDays() {
    this._value._openDays = [];
    return this;
  }
  addAllRewardItems(values) {
    this._value._rewardItems = this._value._rewardItems.concat(values);
    return this;
  }
  addRewardItems(value) {
    this._value._rewardItems = this._value._rewardItems.concat([value]);
    return this;
  }
  setRewardItems(index, value) {
    this._value._rewardItems = this._value._rewardItems.concat();
    this._value._rewardItems[index] = value;
    return this;
  }
  clearRewardItems() {
    this._value._rewardItems = [];
    return this;
  }
  addAllEventAttributes(values) {
    this._value._eventAttributes = this._value._eventAttributes.concat(values);
    return this;
  }
  addEventAttributes(value) {
    this._value._eventAttributes = this._value._eventAttributes.concat([value]);
    return this;
  }
  setEventAttributes(index, value) {
    this._value._eventAttributes = this._value._eventAttributes.concat();
    this._value._eventAttributes[index] = value;
    return this;
  }
  clearEventAttributes() {
    this._value._eventAttributes = [];
    return this;
  }
  setNavigationEntry(value) {
    this._value._hasNavigationEntry = true;
    this._value._navigationEntry = value;
    return this;
  }
  deleteNavigationEntry() {
    this._value._hasNavigationEntry = false;
    this._value._navigationEntry = null;
    return this;
  }
  setActivePointsReward(value) {
    this._value._hasActivePointsReward = true;
    this._value._activePointsReward = value;
    return this;
  }
  deleteActivePointsReward() {
    this._value._hasActivePointsReward = false;
    this._value._activePointsReward = null;
    return this;
  }
  setProgressSyncType(value) {
    this._value._hasProgressSyncType = true;
    this._value._progressSyncType = value;
    return this;
  }
  deleteProgressSyncType() {
    this._value._hasProgressSyncType = false;
    this._value._progressSyncType = null;
    return this;
  }
  addAllProgressRewards(values) {
    this._value._progressRewards = this._value._progressRewards.concat(values);
    return this;
  }
  addProgressRewards(value) {
    this._value._progressRewards = this._value._progressRewards.concat([value]);
    return this;
  }
  setProgressRewards(index, value) {
    this._value._progressRewards = this._value._progressRewards.concat();
    this._value._progressRewards[index] = value;
    return this;
  }
  clearProgressRewards() {
    this._value._progressRewards = [];
    return this;
  }
  setDependentSystem(value) {
    this._value._hasDependentSystem = true;
    this._value._dependentSystem = value;
    return this;
  }
  deleteDependentSystem() {
    this._value._hasDependentSystem = false;
    this._value._dependentSystem = null;
    return this;
  }
}
QuestDefinition.Builder = QuestDefinition_Builder;
class QuestDefinition_WithParent {
  /**
   * @param {QuestDefinition} value
   * @param {QuestDefinition_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return QuestDefinition.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasDescription() {
    if (this._cachedHasDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedHasDescription = true;
      } else {
        this._cachedHasDescription = this._parent ? this._parent.hasDescription : false;
      }
    }
    return this._cachedHasDescription;
  }
  get description() {
    if (this._cachedDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedDescription = this._value.description;
      } else {
        this._cachedDescription = this._parent ? this._parent.description : this._value.description;
      }
    }
    return this._cachedDescription;
  }
  get hasStartProgress() {
    if (this._cachedHasStartProgress === undefined) {
      if (this._value.hasStartProgress) {
        this._cachedHasStartProgress = true;
      } else {
        this._cachedHasStartProgress = this._parent ? this._parent.hasStartProgress : false;
      }
    }
    return this._cachedHasStartProgress;
  }
  get startProgress() {
    if (this._cachedStartProgress === undefined) {
      if (this._value.hasStartProgress) {
        this._cachedStartProgress = this._value.startProgress;
      } else {
        this._cachedStartProgress = this._parent ? this._parent.startProgress : this._value.startProgress;
      }
    }
    return this._cachedStartProgress;
  }
  get hasProgressTotal() {
    if (this._cachedHasProgressTotal === undefined) {
      if (this._value.hasProgressTotal) {
        this._cachedHasProgressTotal = true;
      } else {
        this._cachedHasProgressTotal = this._parent ? this._parent.hasProgressTotal : false;
      }
    }
    return this._cachedHasProgressTotal;
  }
  get progressTotal() {
    if (this._cachedProgressTotal === undefined) {
      if (this._value.hasProgressTotal) {
        this._cachedProgressTotal = this._value.progressTotal;
      } else {
        this._cachedProgressTotal = this._parent ? this._parent.progressTotal : this._value.progressTotal;
      }
    }
    return this._cachedProgressTotal;
  }
  get hasEvent() {
    if (this._cachedHasEvent === undefined) {
      if (this._value.hasEvent) {
        this._cachedHasEvent = true;
      } else {
        this._cachedHasEvent = this._parent ? this._parent.hasEvent : false;
      }
    }
    return this._cachedHasEvent;
  }
  get event() {
    if (this._cachedEvent === undefined) {
      if (this._value.hasEvent) {
        this._cachedEvent = this._value.event;
      } else {
        this._cachedEvent = this._parent ? this._parent.event : this._value.event;
      }
    }
    return this._cachedEvent;
  }
  get hasPresentIfRewarded() {
    if (this._cachedHasPresentIfRewarded === undefined) {
      if (this._value.hasPresentIfRewarded) {
        this._cachedHasPresentIfRewarded = true;
      } else {
        this._cachedHasPresentIfRewarded = this._parent ? this._parent.hasPresentIfRewarded : false;
      }
    }
    return this._cachedHasPresentIfRewarded;
  }
  get presentIfRewarded() {
    if (this._cachedPresentIfRewarded === undefined) {
      if (this._value.hasPresentIfRewarded) {
        this._cachedPresentIfRewarded = this._value.presentIfRewarded;
      } else {
        this._cachedPresentIfRewarded = this._parent ? this._parent.presentIfRewarded : this._value.presentIfRewarded;
      }
    }
    return this._cachedPresentIfRewarded;
  }
  get hasFilter() {
    if (this._cachedHasFilter === undefined) {
      if (this._value.hasFilter) {
        this._cachedHasFilter = true;
      } else {
        this._cachedHasFilter = this._parent ? this._parent.hasFilter : false;
      }
    }
    return this._cachedHasFilter;
  }
  get filter() {
    if (!this._cachedFilter) {
      if (this._value.hasFilter) {
        this._cachedFilter = new Filter.WithParent(this._value.filter, this._parent && this._parent.hasFilter ? this._parent.filter : null);
      } else {
        this._cachedFilter = this._parent ? new Filter.WithParent(Filter.default, this._parent.filter) : Filter.WithParent.default;
      }
    }
    return this._cachedFilter;
  }
  get selfOpenDays() {
    return this._value.openDays;
  }
  get inherentOpenDays() {
    if (!this._inherentOpenDays) {
      this._inherentOpenDays = this._parent ? this._parent.openDays : [];
    }
    return this._inherentOpenDays;
  }
  get openDays() {
    if (!this._allOpenDays) {
      this._allOpenDays = this._parent ? this._parent.openDays.concat(this.selfOpenDays) : this.selfOpenDays;
    }
    return this._allOpenDays;
  }
  get selfRewardItems() {
    if (!this._selfRewardItems) {
      this._selfRewardItems = [];
      for (let i of this._value.rewardItems) {
        this._selfRewardItems.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfRewardItems;
  }
  get inherentRewardItems() {
    if (!this._inherentRewardItems) {
      this._inherentRewardItems = this._parent ? this._parent.rewardItems : [];
    }
    return this._inherentRewardItems;
  }
  get rewardItems() {
    if (!this._allRewardItems) {
      this._allRewardItems = this._parent ? this._parent.rewardItems.concat(this.selfRewardItems) : this.selfRewardItems;
    }
    return this._allRewardItems;
  }
  get selfEventAttributes() {
    if (!this._selfEventAttributes) {
      this._selfEventAttributes = [];
      for (let i of this._value.eventAttributes) {
        this._selfEventAttributes.push(new dcei_wildsky_common_proto.StringStringPair.WithParent(i, null));
      }
    }
    return this._selfEventAttributes;
  }
  get inherentEventAttributes() {
    if (!this._inherentEventAttributes) {
      this._inherentEventAttributes = this._parent ? this._parent.eventAttributes : [];
    }
    return this._inherentEventAttributes;
  }
  get eventAttributes() {
    if (!this._allEventAttributes) {
      this._allEventAttributes = this._parent ? this._parent.eventAttributes.concat(this.selfEventAttributes) : this.selfEventAttributes;
    }
    return this._allEventAttributes;
  }
  get hasNavigationEntry() {
    if (this._cachedHasNavigationEntry === undefined) {
      if (this._value.hasNavigationEntry) {
        this._cachedHasNavigationEntry = true;
      } else {
        this._cachedHasNavigationEntry = this._parent ? this._parent.hasNavigationEntry : false;
      }
    }
    return this._cachedHasNavigationEntry;
  }
  get navigationEntry() {
    if (!this._cachedNavigationEntry) {
      if (this._value.hasNavigationEntry) {
        this._cachedNavigationEntry = new dcei_wildsky_common_proto.PageNavigationEntry.WithParent(this._value.navigationEntry, this._parent && this._parent.hasNavigationEntry ? this._parent.navigationEntry : null);
      } else {
        this._cachedNavigationEntry = this._parent ? new dcei_wildsky_common_proto.PageNavigationEntry.WithParent(dcei_wildsky_common_proto.PageNavigationEntry.default, this._parent.navigationEntry) : dcei_wildsky_common_proto.PageNavigationEntry.WithParent.default;
      }
    }
    return this._cachedNavigationEntry;
  }
  get hasActivePointsReward() {
    if (this._cachedHasActivePointsReward === undefined) {
      if (this._value.hasActivePointsReward) {
        this._cachedHasActivePointsReward = true;
      } else {
        this._cachedHasActivePointsReward = this._parent ? this._parent.hasActivePointsReward : false;
      }
    }
    return this._cachedHasActivePointsReward;
  }
  get activePointsReward() {
    if (this._cachedActivePointsReward === undefined) {
      if (this._value.hasActivePointsReward) {
        this._cachedActivePointsReward = this._value.activePointsReward;
      } else {
        this._cachedActivePointsReward = this._parent ? this._parent.activePointsReward : this._value.activePointsReward;
      }
    }
    return this._cachedActivePointsReward;
  }
  get hasProgressSyncType() {
    if (this._cachedHasProgressSyncType === undefined) {
      if (this._value.hasProgressSyncType) {
        this._cachedHasProgressSyncType = true;
      } else {
        this._cachedHasProgressSyncType = this._parent ? this._parent.hasProgressSyncType : false;
      }
    }
    return this._cachedHasProgressSyncType;
  }
  get progressSyncType() {
    if (this._cachedProgressSyncType === undefined) {
      if (this._value.hasProgressSyncType) {
        this._cachedProgressSyncType = this._value.progressSyncType;
      } else {
        this._cachedProgressSyncType = this._parent ? this._parent.progressSyncType : this._value.progressSyncType;
      }
    }
    return this._cachedProgressSyncType;
  }
  get selfProgressRewards() {
    if (!this._selfProgressRewards) {
      this._selfProgressRewards = [];
      for (let i of this._value.progressRewards) {
        this._selfProgressRewards.push(new QuestDefinition_ProgressedReward.WithParent(i, null));
      }
    }
    return this._selfProgressRewards;
  }
  get inherentProgressRewards() {
    if (!this._inherentProgressRewards) {
      this._inherentProgressRewards = this._parent ? this._parent.progressRewards : [];
    }
    return this._inherentProgressRewards;
  }
  get progressRewards() {
    if (!this._allProgressRewards) {
      this._allProgressRewards = this._parent ? this._parent.progressRewards.concat(this.selfProgressRewards) : this.selfProgressRewards;
    }
    return this._allProgressRewards;
  }
  get hasDependentSystem() {
    if (this._cachedHasDependentSystem === undefined) {
      if (this._value.hasDependentSystem) {
        this._cachedHasDependentSystem = true;
      } else {
        this._cachedHasDependentSystem = this._parent ? this._parent.hasDependentSystem : false;
      }
    }
    return this._cachedHasDependentSystem;
  }
  get dependentSystem() {
    if (this._cachedDependentSystem === undefined) {
      if (this._value.hasDependentSystem) {
        this._cachedDependentSystem = this._value.dependentSystem;
      } else {
        this._cachedDependentSystem = this._parent ? this._parent.dependentSystem : this._value.dependentSystem;
      }
    }
    return this._cachedDependentSystem;
  }
  update(current, parent) {
    const result = new QuestDefinition_WithParent(current, parent);
    if (this._cachedFilter && this._value.hasFilter && current.hasFilter) {
      if (this._value.filter === current.filter && this._parent === parent) {
        result._cachedFilter = this._cachedFilter;
      } else {
        result._cachedFilter = this._cachedFilter.update(current.filter, parent && parent.hasFilter ? parent.filter : null);
      }
    }
    if (this._selfRewardItems) {
      if (this._value.rewardItems === current.rewardItems) {
        result._selfRewardItems = this._selfRewardItems;
      } else {
        result._selfRewardItems = [];
        for (let i = 0; i < current.rewardItems.length; i++) {
          const oldValue = this._value.rewardItems[i];
          if (oldValue) {
            const oldCache = this._selfRewardItems[i];
            if (oldValue === current.rewardItems[i]) {
              result._selfRewardItems[i] = oldCache;
            } else {
              result._selfRewardItems[i] = oldCache.update(current.rewardItems[i], null);
            }
          } else {
            result._selfRewardItems[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.rewardItems[i], null);
          }
        }
      }
    }
    if (this._selfEventAttributes) {
      if (this._value.eventAttributes === current.eventAttributes) {
        result._selfEventAttributes = this._selfEventAttributes;
      } else {
        result._selfEventAttributes = [];
        for (let i = 0; i < current.eventAttributes.length; i++) {
          const oldValue = this._value.eventAttributes[i];
          if (oldValue) {
            const oldCache = this._selfEventAttributes[i];
            if (oldValue === current.eventAttributes[i]) {
              result._selfEventAttributes[i] = oldCache;
            } else {
              result._selfEventAttributes[i] = oldCache.update(current.eventAttributes[i], null);
            }
          } else {
            result._selfEventAttributes[i] = new dcei_wildsky_common_proto.StringStringPair.WithParent(current.eventAttributes[i], null);
          }
        }
      }
    }
    if (this._cachedNavigationEntry && this._value.hasNavigationEntry && current.hasNavigationEntry) {
      if (this._value.navigationEntry === current.navigationEntry && this._parent === parent) {
        result._cachedNavigationEntry = this._cachedNavigationEntry;
      } else {
        result._cachedNavigationEntry = this._cachedNavigationEntry.update(current.navigationEntry, parent && parent.hasNavigationEntry ? parent.navigationEntry : null);
      }
    }
    if (this._selfProgressRewards) {
      if (this._value.progressRewards === current.progressRewards) {
        result._selfProgressRewards = this._selfProgressRewards;
      } else {
        result._selfProgressRewards = [];
        for (let i = 0; i < current.progressRewards.length; i++) {
          const oldValue = this._value.progressRewards[i];
          if (oldValue) {
            const oldCache = this._selfProgressRewards[i];
            if (oldValue === current.progressRewards[i]) {
              result._selfProgressRewards[i] = oldCache;
            } else {
              result._selfProgressRewards[i] = oldCache.update(current.progressRewards[i], null);
            }
          } else {
            result._selfProgressRewards[i] = new QuestDefinition_ProgressedReward.WithParent(current.progressRewards[i], null);
          }
        }
      }
    }
    return result;
  }
}
QuestDefinition_WithParent.default = new QuestDefinition_WithParent(QuestDefinition.default, null);
QuestDefinition.WithParent = QuestDefinition_WithParent;
class QuestDefinition_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get description() {
    if (!this._description) {
      this._description = {
        name: "description",
        Name: "Description",
        number: 3,
        protoType: 9,
        protoName: "description",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._description;
  }
  get startProgress() {
    if (!this._startProgress) {
      this._startProgress = {
        name: "startProgress",
        Name: "StartProgress",
        number: 4,
        protoType: 5,
        protoName: "start_progress",
        type: JsonToInt32,
        options: {
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startProgress;
  }
  get progressTotal() {
    if (!this._progressTotal) {
      this._progressTotal = {
        name: "progressTotal",
        Name: "ProgressTotal",
        number: 5,
        protoType: 5,
        protoName: "progress_total",
        type: JsonToInt32,
        options: {
          min: 1,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._progressTotal;
  }
  get event() {
    if (!this._event) {
      this._event = {
        name: "event",
        Name: "Event",
        number: 6,
        protoType: 9,
        protoName: "event",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._event;
  }
  get presentIfRewarded() {
    if (!this._presentIfRewarded) {
      this._presentIfRewarded = {
        name: "presentIfRewarded",
        Name: "PresentIfRewarded",
        number: 9,
        protoType: 8,
        protoName: "present_if_rewarded",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._presentIfRewarded;
  }
  get filter() {
    if (!this._filter) {
      this._filter = {
        name: "filter",
        Name: "Filter",
        number: 10,
        protoType: 11,
        protoName: "filter",
        type: Filter,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._filter;
  }
  get openDays() {
    if (!this._openDays) {
      this._openDays = {
        name: "openDays",
        Name: "OpenDays",
        number: 11,
        protoType: 9,
        protoName: "open_days",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "DailyQuestOpenDaysStringList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._openDays;
  }
  get rewardItems() {
    if (!this._rewardItems) {
      this._rewardItems = {
        name: "rewardItems",
        Name: "RewardItems",
        number: 12,
        protoType: 11,
        protoName: "reward_items",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
          comments: "This will be ignored if progress_rewards is set",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewardItems;
  }
  get eventAttributes() {
    if (!this._eventAttributes) {
      this._eventAttributes = {
        name: "eventAttributes",
        Name: "EventAttributes",
        number: 13,
        protoType: 11,
        protoName: "event_attributes",
        type: dcei_wildsky_common_proto.StringStringPair,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventAttributes;
  }
  get navigationEntry() {
    if (!this._navigationEntry) {
      this._navigationEntry = {
        name: "navigationEntry",
        Name: "NavigationEntry",
        number: 14,
        protoType: 11,
        protoName: "navigation_entry",
        type: dcei_wildsky_common_proto.PageNavigationEntry,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._navigationEntry;
  }
  get activePointsReward() {
    if (!this._activePointsReward) {
      this._activePointsReward = {
        name: "activePointsReward",
        Name: "ActivePointsReward",
        number: 15,
        protoType: 5,
        protoName: "active_points_reward",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._activePointsReward;
  }
  get progressSyncType() {
    if (!this._progressSyncType) {
      this._progressSyncType = {
        name: "progressSyncType",
        Name: "ProgressSyncType",
        number: 16,
        protoType: 14,
        protoName: "progress_sync_type",
        type: QuestDefinition_ProgressSyncType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._progressSyncType;
  }
  get progressRewards() {
    if (!this._progressRewards) {
      this._progressRewards = {
        name: "progressRewards",
        Name: "ProgressRewards",
        number: 17,
        protoType: 11,
        protoName: "progress_rewards",
        type: QuestDefinition_ProgressedReward,
        isRepeated: true,
        options: {
          comments: "If this has data, rewards_item will be ignored",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._progressRewards;
  }
  get dependentSystem() {
    if (!this._dependentSystem) {
      this._dependentSystem = {
        name: "dependentSystem",
        Name: "DependentSystem",
        number: 18,
        protoType: 9,
        protoName: "dependent_system",
        type: JsonToString,
        options: {
          comments: "Enter system name here so the quest will be hiden if the system is locked Names must match with ones in SystemUnlockProgress.lua.txt",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dependentSystem;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.description,
        this.startProgress,
        this.progressTotal,
        this.event,
        this.presentIfRewarded,
        this.filter,
        this.openDays,
        this.rewardItems,
        this.eventAttributes,
        this.navigationEntry,
        this.activePointsReward,
        this.progressSyncType,
        this.progressRewards,
        this.dependentSystem,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDescription",
        Name: "DummyOneofForDescription",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStartProgress",
        Name: "DummyOneofForStartProgress",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForProgressTotal",
        Name: "DummyOneofForProgressTotal",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEvent",
        Name: "DummyOneofForEvent",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPresentIfRewarded",
        Name: "DummyOneofForPresentIfRewarded",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFilter",
        Name: "DummyOneofForFilter",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForNavigationEntry",
        Name: "DummyOneofForNavigationEntry",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForActivePointsReward",
        Name: "DummyOneofForActivePointsReward",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForProgressSyncType",
        Name: "DummyOneofForProgressSyncType",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDependentSystem",
        Name: "DummyOneofForDependentSystem",
        fields: [
          this.fields[14],
        ],
      });
    }
    return this._oneofs;
  }
}
QuestDefinition.descriptor = new QuestDefinition_Descriptor();
export class AchievementDefinition {
  get descriptor() {
    return AchievementDefinition.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasDescription = false;
    this._description = null;
    this._hasStartProgress = false;
    this._startProgress = null;
    this._hasProgressTotal = false;
    this._progressTotal = null;
    this._hasEvent = false;
    this._event = null;
    this._hasPresentIfRewarded = false;
    this._presentIfRewarded = null;
    this._hasFilter = false;
    this._filter = null;
    this._rewardItems = [];
    this._eventAttributes = [];
    this._hasNavigationEntry = false;
    this._navigationEntry = null;
    this._hasDependentSystem = false;
    this._dependentSystem = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasDescription) return false;
    if (this._hasStartProgress) return false;
    if (this._hasProgressTotal) return false;
    if (this._hasEvent) return false;
    if (this._hasPresentIfRewarded) return false;
    if (this._hasFilter && !this._filter.isEmpty()) return false;
    if (this._rewardItems.length > 0) return false;
    if (this._eventAttributes.length > 0) return false;
    if (this._hasNavigationEntry && !this._navigationEntry.isEmpty()) return false;
    if (this._hasDependentSystem) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof AchievementDefinition) {
      return value;
    }
    return AchievementDefinition.fromJson(value);
  }
  static fromJson(json) {
    const result = new AchievementDefinition();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.description != null) {
      result._hasDescription = true;
      result._description = JsonToString.fromJson(json.description);
    }
    if (json.startProgress != null) {
      result._hasStartProgress = true;
      result._startProgress = JsonToInt32.fromJson(json.startProgress);
    }
    if (json.progressTotal != null) {
      result._hasProgressTotal = true;
      result._progressTotal = JsonToInt32.fromJson(json.progressTotal);
    }
    if (json.event != null) {
      result._hasEvent = true;
      result._event = JsonToString.fromJson(json.event);
    }
    if (json.presentIfRewarded != null) {
      result._hasPresentIfRewarded = true;
      result._presentIfRewarded = JsonToBoolean.fromJson(json.presentIfRewarded);
    }
    if (json.filter != null) {
      result._hasFilter = true;
      result._filter = Filter.fromJson(json.filter);
    }
    result._rewardItems = JsonToList(json.rewardItems, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    result._eventAttributes = JsonToList(json.eventAttributes, dcei_wildsky_common_proto.StringStringPair);
    if (json.navigationEntry != null) {
      result._hasNavigationEntry = true;
      result._navigationEntry = dcei_wildsky_common_proto.PageNavigationEntry.fromJson(json.navigationEntry);
    }
    if (json.dependentSystem != null) {
      result._hasDependentSystem = true;
      result._dependentSystem = JsonToString.fromJson(json.dependentSystem);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasDescription) {
      result.description = JsonToString.toJson(this._description);
    }
    if (this._hasStartProgress) {
      result.startProgress = JsonToInt32.toJson(this._startProgress);
    }
    if (this._hasProgressTotal) {
      result.progressTotal = JsonToInt32.toJson(this._progressTotal);
    }
    if (this._hasEvent) {
      result.event = JsonToString.toJson(this._event);
    }
    if (this._hasPresentIfRewarded) {
      result.presentIfRewarded = JsonToBoolean.toJson(this._presentIfRewarded);
    }
    if (this._hasFilter && !this._filter.isEmpty()) {
      result.filter = Filter.toJson(this._filter);
    }
    if (this._rewardItems.length > 0) {
      result.rewardItems = ArrayToJson(this._rewardItems, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    if (this._eventAttributes.length > 0) {
      result.eventAttributes = ArrayToJson(this._eventAttributes, dcei_wildsky_common_proto.StringStringPair);
    }
    if (this._hasNavigationEntry && !this._navigationEntry.isEmpty()) {
      result.navigationEntry = dcei_wildsky_common_proto.PageNavigationEntry.toJson(this._navigationEntry);
    }
    if (this._hasDependentSystem) {
      result.dependentSystem = JsonToString.toJson(this._dependentSystem);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {string}
   */
  get description() {
    return this._hasDescription ? this._description : JsonToString.default;
  }
  get hasDescription() {
    return this._hasDescription;
  }
  setDescription(path, value) {
    return {type: 'SET', path: path.concat(['description']), value};
  }
  deleteDescription(path) {
    return {type: 'DELETE', path: path.concat(['description'])};
  }
  /**
   * @returns {number}
   */
  get startProgress() {
    return this._hasStartProgress ? this._startProgress : JsonToInt32.default;
  }
  get hasStartProgress() {
    return this._hasStartProgress;
  }
  setStartProgress(path, value) {
    return {type: 'SET', path: path.concat(['startProgress']), value};
  }
  deleteStartProgress(path) {
    return {type: 'DELETE', path: path.concat(['startProgress'])};
  }
  /**
   * @returns {number}
   */
  get progressTotal() {
    return this._hasProgressTotal ? this._progressTotal : JsonToInt32.default;
  }
  get hasProgressTotal() {
    return this._hasProgressTotal;
  }
  setProgressTotal(path, value) {
    return {type: 'SET', path: path.concat(['progressTotal']), value};
  }
  deleteProgressTotal(path) {
    return {type: 'DELETE', path: path.concat(['progressTotal'])};
  }
  /**
   * @returns {string}
   */
  get event() {
    return this._hasEvent ? this._event : JsonToString.default;
  }
  get hasEvent() {
    return this._hasEvent;
  }
  setEvent(path, value) {
    return {type: 'SET', path: path.concat(['event']), value};
  }
  deleteEvent(path) {
    return {type: 'DELETE', path: path.concat(['event'])};
  }
  /**
   * @returns {boolean}
   */
  get presentIfRewarded() {
    return this._hasPresentIfRewarded ? this._presentIfRewarded : JsonToBoolean.default;
  }
  get hasPresentIfRewarded() {
    return this._hasPresentIfRewarded;
  }
  setPresentIfRewarded(path, value) {
    return {type: 'SET', path: path.concat(['presentIfRewarded']), value};
  }
  deletePresentIfRewarded(path) {
    return {type: 'DELETE', path: path.concat(['presentIfRewarded'])};
  }
  /**
   * @returns {Filter}
   */
  get filter() {
    return this._hasFilter ? this._filter : Filter.default;
  }
  get hasFilter() {
    return this._hasFilter;
  }
  setFilter(path, value) {
    return {type: 'SET', path: path.concat(['filter']), value: value.toJson()};
  }
  deleteFilter(path) {
    return {type: 'DELETE', path: path.concat(['filter'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get rewardItems() {
    return this._rewardItems;
  }
  addRewardItems(path, value) {
    return {type: 'ADD', path: path.concat(['rewardItems']), value: value.toJson()};
  }
  setRewardItems(path, value) {
    return {type: 'SET', path: path.concat(['rewardItems']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setRewardItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewardItems', key]), value: value.toJson()};
  }
  deleteRewardItems(path) {
    return {type: 'DELETE', path: path.concat(['rewardItems'])};
  }
  deleteRewardItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewardItems', key])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.StringStringPair[]}
   */
  get eventAttributes() {
    return this._eventAttributes;
  }
  addEventAttributes(path, value) {
    return {type: 'ADD', path: path.concat(['eventAttributes']), value: value.toJson()};
  }
  setEventAttributes(path, value) {
    return {type: 'SET', path: path.concat(['eventAttributes']), value: ArrayToJson(value, dcei_wildsky_common_proto.StringStringPair)};
  }
  setEventAttributesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['eventAttributes', key]), value: value.toJson()};
  }
  deleteEventAttributes(path) {
    return {type: 'DELETE', path: path.concat(['eventAttributes'])};
  }
  deleteEventAttributesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['eventAttributes', key])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.PageNavigationEntry}
   */
  get navigationEntry() {
    return this._hasNavigationEntry ? this._navigationEntry : dcei_wildsky_common_proto.PageNavigationEntry.default;
  }
  get hasNavigationEntry() {
    return this._hasNavigationEntry;
  }
  setNavigationEntry(path, value) {
    return {type: 'SET', path: path.concat(['navigationEntry']), value: value.toJson()};
  }
  deleteNavigationEntry(path) {
    return {type: 'DELETE', path: path.concat(['navigationEntry'])};
  }
  /**
   * @returns {string}
   */
  get dependentSystem() {
    return this._hasDependentSystem ? this._dependentSystem : JsonToString.default;
  }
  get hasDependentSystem() {
    return this._hasDependentSystem;
  }
  setDependentSystem(path, value) {
    return {type: 'SET', path: path.concat(['dependentSystem']), value};
  }
  deleteDependentSystem(path) {
    return {type: 'DELETE', path: path.concat(['dependentSystem'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AchievementDefinition(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new AchievementDefinition(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "description": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AchievementDefinition(this);
              copy._hasDescription = true;
              copy._description = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDescription) {
                return this;
              }
              const copy = new AchievementDefinition(this);
              copy._hasDescription = false;
              copy._description = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "startProgress": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AchievementDefinition(this);
              copy._hasStartProgress = true;
              copy._startProgress = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartProgress) {
                return this;
              }
              const copy = new AchievementDefinition(this);
              copy._hasStartProgress = false;
              copy._startProgress = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "progressTotal": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AchievementDefinition(this);
              copy._hasProgressTotal = true;
              copy._progressTotal = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasProgressTotal) {
                return this;
              }
              const copy = new AchievementDefinition(this);
              copy._hasProgressTotal = false;
              copy._progressTotal = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "event": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AchievementDefinition(this);
              copy._hasEvent = true;
              copy._event = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEvent) {
                return this;
              }
              const copy = new AchievementDefinition(this);
              copy._hasEvent = false;
              copy._event = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "presentIfRewarded": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AchievementDefinition(this);
              copy._hasPresentIfRewarded = true;
              copy._presentIfRewarded = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPresentIfRewarded) {
                return this;
              }
              const copy = new AchievementDefinition(this);
              copy._hasPresentIfRewarded = false;
              copy._presentIfRewarded = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "filter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AchievementDefinition(this);
              copy._hasFilter = true;
              copy._filter = Filter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFilter) {
                return this;
              }
              const copy = new AchievementDefinition(this);
              copy._hasFilter = false;
              copy._filter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasFilter) {
            const copy = new AchievementDefinition(this);
            copy._hasFilter = true;
            copy._filter = Filter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._filter.apply(type, path.slice(1), value);
          if (newValue === this._filter) {
            return this;
          }
          const copy = new AchievementDefinition(this);
          copy._filter = copy._filter.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "rewardItems": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AchievementDefinition(this);
              copy._rewardItems = [];        for (let i of value) {
                copy._rewardItems.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new AchievementDefinition(this);
              copy._rewardItems = copy._rewardItems.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewardItems.length === 0) {
                return this;
              }
              const copy = new AchievementDefinition(this);
              copy._rewardItems = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewardItems.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new AchievementDefinition(this);
              copy._rewardItems = copy._rewardItems.slice();
              copy._rewardItems[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new AchievementDefinition(this);
              copy._rewardItems = copy._rewardItems.slice(0, path[1]).concat(copy._rewardItems.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewardItems.length) {
            return this;
          }
          const oldValue = this._rewardItems[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new AchievementDefinition(this);
          copy._rewardItems = copy._rewardItems.slice();
          copy._rewardItems[key] = newValue;
          return copy;
        }
      }
      case "eventAttributes": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AchievementDefinition(this);
              copy._eventAttributes = [];        for (let i of value) {
                copy._eventAttributes.push(dcei_wildsky_common_proto.StringStringPair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new AchievementDefinition(this);
              copy._eventAttributes = copy._eventAttributes.concat([dcei_wildsky_common_proto.StringStringPair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._eventAttributes.length === 0) {
                return this;
              }
              const copy = new AchievementDefinition(this);
              copy._eventAttributes = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._eventAttributes.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new AchievementDefinition(this);
              copy._eventAttributes = copy._eventAttributes.slice();
              copy._eventAttributes[path[1]] = dcei_wildsky_common_proto.StringStringPair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new AchievementDefinition(this);
              copy._eventAttributes = copy._eventAttributes.slice(0, path[1]).concat(copy._eventAttributes.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._eventAttributes.length) {
            return this;
          }
          const oldValue = this._eventAttributes[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new AchievementDefinition(this);
          copy._eventAttributes = copy._eventAttributes.slice();
          copy._eventAttributes[key] = newValue;
          return copy;
        }
      }
      case "navigationEntry": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AchievementDefinition(this);
              copy._hasNavigationEntry = true;
              copy._navigationEntry = dcei_wildsky_common_proto.PageNavigationEntry.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNavigationEntry) {
                return this;
              }
              const copy = new AchievementDefinition(this);
              copy._hasNavigationEntry = false;
              copy._navigationEntry = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasNavigationEntry) {
            const copy = new AchievementDefinition(this);
            copy._hasNavigationEntry = true;
            copy._navigationEntry = dcei_wildsky_common_proto.PageNavigationEntry.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._navigationEntry.apply(type, path.slice(1), value);
          if (newValue === this._navigationEntry) {
            return this;
          }
          const copy = new AchievementDefinition(this);
          copy._navigationEntry = copy._navigationEntry.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "dependentSystem": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AchievementDefinition(this);
              copy._hasDependentSystem = true;
              copy._dependentSystem = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDependentSystem) {
                return this;
              }
              const copy = new AchievementDefinition(this);
              copy._hasDependentSystem = false;
              copy._dependentSystem = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {AchievementDefinition} other
   * @returns {AchievementDefinition}
   */
  merge(other) {
    const copy = new AchievementDefinition(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasDescription) {
      copy._hasDescription = true;
      copy._description = other._description;
    }
    if (other._hasStartProgress) {
      copy._hasStartProgress = true;
      copy._startProgress = other._startProgress;
    }
    if (other._hasProgressTotal) {
      copy._hasProgressTotal = true;
      copy._progressTotal = other._progressTotal;
    }
    if (other._hasEvent) {
      copy._hasEvent = true;
      copy._event = other._event;
    }
    if (other._hasPresentIfRewarded) {
      copy._hasPresentIfRewarded = true;
      copy._presentIfRewarded = other._presentIfRewarded;
    }
    if (other._hasFilter) {
      if (copy._hasFilter) {
        copy._filter = copy.filter.merge(other.filter);
      } else {
        copy._filter = other._filter;
      }
      copy._hasFilter = true;
    }
    copy._rewardItems = this._rewardItems.concat(other._rewardItems);
    copy._eventAttributes = this._eventAttributes.concat(other._eventAttributes);
    if (other._hasNavigationEntry) {
      if (copy._hasNavigationEntry) {
        copy._navigationEntry = copy.navigationEntry.merge(other.navigationEntry);
      } else {
        copy._navigationEntry = other._navigationEntry;
      }
      copy._hasNavigationEntry = true;
    }
    if (other._hasDependentSystem) {
      copy._hasDependentSystem = true;
      copy._dependentSystem = other._dependentSystem;
    }
    return copy;
  }
}
AchievementDefinition.default = new AchievementDefinition();
class AchievementDefinition_Builder {
  constructor(value) {
    this._value = new AchievementDefinition(value);
  }
  build() {
    return new AchievementDefinition(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setDescription(value) {
    this._value._hasDescription = true;
    this._value._description = value;
    return this;
  }
  deleteDescription() {
    this._value._hasDescription = false;
    this._value._description = null;
    return this;
  }
  setStartProgress(value) {
    this._value._hasStartProgress = true;
    this._value._startProgress = value;
    return this;
  }
  deleteStartProgress() {
    this._value._hasStartProgress = false;
    this._value._startProgress = null;
    return this;
  }
  setProgressTotal(value) {
    this._value._hasProgressTotal = true;
    this._value._progressTotal = value;
    return this;
  }
  deleteProgressTotal() {
    this._value._hasProgressTotal = false;
    this._value._progressTotal = null;
    return this;
  }
  setEvent(value) {
    this._value._hasEvent = true;
    this._value._event = value;
    return this;
  }
  deleteEvent() {
    this._value._hasEvent = false;
    this._value._event = null;
    return this;
  }
  setPresentIfRewarded(value) {
    this._value._hasPresentIfRewarded = true;
    this._value._presentIfRewarded = value;
    return this;
  }
  deletePresentIfRewarded() {
    this._value._hasPresentIfRewarded = false;
    this._value._presentIfRewarded = null;
    return this;
  }
  setFilter(value) {
    this._value._hasFilter = true;
    this._value._filter = value;
    return this;
  }
  deleteFilter() {
    this._value._hasFilter = false;
    this._value._filter = null;
    return this;
  }
  addAllRewardItems(values) {
    this._value._rewardItems = this._value._rewardItems.concat(values);
    return this;
  }
  addRewardItems(value) {
    this._value._rewardItems = this._value._rewardItems.concat([value]);
    return this;
  }
  setRewardItems(index, value) {
    this._value._rewardItems = this._value._rewardItems.concat();
    this._value._rewardItems[index] = value;
    return this;
  }
  clearRewardItems() {
    this._value._rewardItems = [];
    return this;
  }
  addAllEventAttributes(values) {
    this._value._eventAttributes = this._value._eventAttributes.concat(values);
    return this;
  }
  addEventAttributes(value) {
    this._value._eventAttributes = this._value._eventAttributes.concat([value]);
    return this;
  }
  setEventAttributes(index, value) {
    this._value._eventAttributes = this._value._eventAttributes.concat();
    this._value._eventAttributes[index] = value;
    return this;
  }
  clearEventAttributes() {
    this._value._eventAttributes = [];
    return this;
  }
  setNavigationEntry(value) {
    this._value._hasNavigationEntry = true;
    this._value._navigationEntry = value;
    return this;
  }
  deleteNavigationEntry() {
    this._value._hasNavigationEntry = false;
    this._value._navigationEntry = null;
    return this;
  }
  setDependentSystem(value) {
    this._value._hasDependentSystem = true;
    this._value._dependentSystem = value;
    return this;
  }
  deleteDependentSystem() {
    this._value._hasDependentSystem = false;
    this._value._dependentSystem = null;
    return this;
  }
}
AchievementDefinition.Builder = AchievementDefinition_Builder;
class AchievementDefinition_WithParent {
  /**
   * @param {AchievementDefinition} value
   * @param {AchievementDefinition_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return AchievementDefinition.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasDescription() {
    if (this._cachedHasDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedHasDescription = true;
      } else {
        this._cachedHasDescription = this._parent ? this._parent.hasDescription : false;
      }
    }
    return this._cachedHasDescription;
  }
  get description() {
    if (this._cachedDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedDescription = this._value.description;
      } else {
        this._cachedDescription = this._parent ? this._parent.description : this._value.description;
      }
    }
    return this._cachedDescription;
  }
  get hasStartProgress() {
    if (this._cachedHasStartProgress === undefined) {
      if (this._value.hasStartProgress) {
        this._cachedHasStartProgress = true;
      } else {
        this._cachedHasStartProgress = this._parent ? this._parent.hasStartProgress : false;
      }
    }
    return this._cachedHasStartProgress;
  }
  get startProgress() {
    if (this._cachedStartProgress === undefined) {
      if (this._value.hasStartProgress) {
        this._cachedStartProgress = this._value.startProgress;
      } else {
        this._cachedStartProgress = this._parent ? this._parent.startProgress : this._value.startProgress;
      }
    }
    return this._cachedStartProgress;
  }
  get hasProgressTotal() {
    if (this._cachedHasProgressTotal === undefined) {
      if (this._value.hasProgressTotal) {
        this._cachedHasProgressTotal = true;
      } else {
        this._cachedHasProgressTotal = this._parent ? this._parent.hasProgressTotal : false;
      }
    }
    return this._cachedHasProgressTotal;
  }
  get progressTotal() {
    if (this._cachedProgressTotal === undefined) {
      if (this._value.hasProgressTotal) {
        this._cachedProgressTotal = this._value.progressTotal;
      } else {
        this._cachedProgressTotal = this._parent ? this._parent.progressTotal : this._value.progressTotal;
      }
    }
    return this._cachedProgressTotal;
  }
  get hasEvent() {
    if (this._cachedHasEvent === undefined) {
      if (this._value.hasEvent) {
        this._cachedHasEvent = true;
      } else {
        this._cachedHasEvent = this._parent ? this._parent.hasEvent : false;
      }
    }
    return this._cachedHasEvent;
  }
  get event() {
    if (this._cachedEvent === undefined) {
      if (this._value.hasEvent) {
        this._cachedEvent = this._value.event;
      } else {
        this._cachedEvent = this._parent ? this._parent.event : this._value.event;
      }
    }
    return this._cachedEvent;
  }
  get hasPresentIfRewarded() {
    if (this._cachedHasPresentIfRewarded === undefined) {
      if (this._value.hasPresentIfRewarded) {
        this._cachedHasPresentIfRewarded = true;
      } else {
        this._cachedHasPresentIfRewarded = this._parent ? this._parent.hasPresentIfRewarded : false;
      }
    }
    return this._cachedHasPresentIfRewarded;
  }
  get presentIfRewarded() {
    if (this._cachedPresentIfRewarded === undefined) {
      if (this._value.hasPresentIfRewarded) {
        this._cachedPresentIfRewarded = this._value.presentIfRewarded;
      } else {
        this._cachedPresentIfRewarded = this._parent ? this._parent.presentIfRewarded : this._value.presentIfRewarded;
      }
    }
    return this._cachedPresentIfRewarded;
  }
  get hasFilter() {
    if (this._cachedHasFilter === undefined) {
      if (this._value.hasFilter) {
        this._cachedHasFilter = true;
      } else {
        this._cachedHasFilter = this._parent ? this._parent.hasFilter : false;
      }
    }
    return this._cachedHasFilter;
  }
  get filter() {
    if (!this._cachedFilter) {
      if (this._value.hasFilter) {
        this._cachedFilter = new Filter.WithParent(this._value.filter, this._parent && this._parent.hasFilter ? this._parent.filter : null);
      } else {
        this._cachedFilter = this._parent ? new Filter.WithParent(Filter.default, this._parent.filter) : Filter.WithParent.default;
      }
    }
    return this._cachedFilter;
  }
  get selfRewardItems() {
    if (!this._selfRewardItems) {
      this._selfRewardItems = [];
      for (let i of this._value.rewardItems) {
        this._selfRewardItems.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfRewardItems;
  }
  get inherentRewardItems() {
    if (!this._inherentRewardItems) {
      this._inherentRewardItems = this._parent ? this._parent.rewardItems : [];
    }
    return this._inherentRewardItems;
  }
  get rewardItems() {
    if (!this._allRewardItems) {
      this._allRewardItems = this._parent ? this._parent.rewardItems.concat(this.selfRewardItems) : this.selfRewardItems;
    }
    return this._allRewardItems;
  }
  get selfEventAttributes() {
    if (!this._selfEventAttributes) {
      this._selfEventAttributes = [];
      for (let i of this._value.eventAttributes) {
        this._selfEventAttributes.push(new dcei_wildsky_common_proto.StringStringPair.WithParent(i, null));
      }
    }
    return this._selfEventAttributes;
  }
  get inherentEventAttributes() {
    if (!this._inherentEventAttributes) {
      this._inherentEventAttributes = this._parent ? this._parent.eventAttributes : [];
    }
    return this._inherentEventAttributes;
  }
  get eventAttributes() {
    if (!this._allEventAttributes) {
      this._allEventAttributes = this._parent ? this._parent.eventAttributes.concat(this.selfEventAttributes) : this.selfEventAttributes;
    }
    return this._allEventAttributes;
  }
  get hasNavigationEntry() {
    if (this._cachedHasNavigationEntry === undefined) {
      if (this._value.hasNavigationEntry) {
        this._cachedHasNavigationEntry = true;
      } else {
        this._cachedHasNavigationEntry = this._parent ? this._parent.hasNavigationEntry : false;
      }
    }
    return this._cachedHasNavigationEntry;
  }
  get navigationEntry() {
    if (!this._cachedNavigationEntry) {
      if (this._value.hasNavigationEntry) {
        this._cachedNavigationEntry = new dcei_wildsky_common_proto.PageNavigationEntry.WithParent(this._value.navigationEntry, this._parent && this._parent.hasNavigationEntry ? this._parent.navigationEntry : null);
      } else {
        this._cachedNavigationEntry = this._parent ? new dcei_wildsky_common_proto.PageNavigationEntry.WithParent(dcei_wildsky_common_proto.PageNavigationEntry.default, this._parent.navigationEntry) : dcei_wildsky_common_proto.PageNavigationEntry.WithParent.default;
      }
    }
    return this._cachedNavigationEntry;
  }
  get hasDependentSystem() {
    if (this._cachedHasDependentSystem === undefined) {
      if (this._value.hasDependentSystem) {
        this._cachedHasDependentSystem = true;
      } else {
        this._cachedHasDependentSystem = this._parent ? this._parent.hasDependentSystem : false;
      }
    }
    return this._cachedHasDependentSystem;
  }
  get dependentSystem() {
    if (this._cachedDependentSystem === undefined) {
      if (this._value.hasDependentSystem) {
        this._cachedDependentSystem = this._value.dependentSystem;
      } else {
        this._cachedDependentSystem = this._parent ? this._parent.dependentSystem : this._value.dependentSystem;
      }
    }
    return this._cachedDependentSystem;
  }
  update(current, parent) {
    const result = new AchievementDefinition_WithParent(current, parent);
    if (this._cachedFilter && this._value.hasFilter && current.hasFilter) {
      if (this._value.filter === current.filter && this._parent === parent) {
        result._cachedFilter = this._cachedFilter;
      } else {
        result._cachedFilter = this._cachedFilter.update(current.filter, parent && parent.hasFilter ? parent.filter : null);
      }
    }
    if (this._selfRewardItems) {
      if (this._value.rewardItems === current.rewardItems) {
        result._selfRewardItems = this._selfRewardItems;
      } else {
        result._selfRewardItems = [];
        for (let i = 0; i < current.rewardItems.length; i++) {
          const oldValue = this._value.rewardItems[i];
          if (oldValue) {
            const oldCache = this._selfRewardItems[i];
            if (oldValue === current.rewardItems[i]) {
              result._selfRewardItems[i] = oldCache;
            } else {
              result._selfRewardItems[i] = oldCache.update(current.rewardItems[i], null);
            }
          } else {
            result._selfRewardItems[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.rewardItems[i], null);
          }
        }
      }
    }
    if (this._selfEventAttributes) {
      if (this._value.eventAttributes === current.eventAttributes) {
        result._selfEventAttributes = this._selfEventAttributes;
      } else {
        result._selfEventAttributes = [];
        for (let i = 0; i < current.eventAttributes.length; i++) {
          const oldValue = this._value.eventAttributes[i];
          if (oldValue) {
            const oldCache = this._selfEventAttributes[i];
            if (oldValue === current.eventAttributes[i]) {
              result._selfEventAttributes[i] = oldCache;
            } else {
              result._selfEventAttributes[i] = oldCache.update(current.eventAttributes[i], null);
            }
          } else {
            result._selfEventAttributes[i] = new dcei_wildsky_common_proto.StringStringPair.WithParent(current.eventAttributes[i], null);
          }
        }
      }
    }
    if (this._cachedNavigationEntry && this._value.hasNavigationEntry && current.hasNavigationEntry) {
      if (this._value.navigationEntry === current.navigationEntry && this._parent === parent) {
        result._cachedNavigationEntry = this._cachedNavigationEntry;
      } else {
        result._cachedNavigationEntry = this._cachedNavigationEntry.update(current.navigationEntry, parent && parent.hasNavigationEntry ? parent.navigationEntry : null);
      }
    }
    return result;
  }
}
AchievementDefinition_WithParent.default = new AchievementDefinition_WithParent(AchievementDefinition.default, null);
AchievementDefinition.WithParent = AchievementDefinition_WithParent;
class AchievementDefinition_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get description() {
    if (!this._description) {
      this._description = {
        name: "description",
        Name: "Description",
        number: 3,
        protoType: 9,
        protoName: "description",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._description;
  }
  get startProgress() {
    if (!this._startProgress) {
      this._startProgress = {
        name: "startProgress",
        Name: "StartProgress",
        number: 4,
        protoType: 5,
        protoName: "start_progress",
        type: JsonToInt32,
        options: {
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startProgress;
  }
  get progressTotal() {
    if (!this._progressTotal) {
      this._progressTotal = {
        name: "progressTotal",
        Name: "ProgressTotal",
        number: 5,
        protoType: 5,
        protoName: "progress_total",
        type: JsonToInt32,
        options: {
          min: 1,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._progressTotal;
  }
  get event() {
    if (!this._event) {
      this._event = {
        name: "event",
        Name: "Event",
        number: 6,
        protoType: 9,
        protoName: "event",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._event;
  }
  get presentIfRewarded() {
    if (!this._presentIfRewarded) {
      this._presentIfRewarded = {
        name: "presentIfRewarded",
        Name: "PresentIfRewarded",
        number: 9,
        protoType: 8,
        protoName: "present_if_rewarded",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._presentIfRewarded;
  }
  get filter() {
    if (!this._filter) {
      this._filter = {
        name: "filter",
        Name: "Filter",
        number: 10,
        protoType: 11,
        protoName: "filter",
        type: Filter,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._filter;
  }
  get rewardItems() {
    if (!this._rewardItems) {
      this._rewardItems = {
        name: "rewardItems",
        Name: "RewardItems",
        number: 11,
        protoType: 11,
        protoName: "reward_items",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewardItems;
  }
  get eventAttributes() {
    if (!this._eventAttributes) {
      this._eventAttributes = {
        name: "eventAttributes",
        Name: "EventAttributes",
        number: 12,
        protoType: 11,
        protoName: "event_attributes",
        type: dcei_wildsky_common_proto.StringStringPair,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventAttributes;
  }
  get navigationEntry() {
    if (!this._navigationEntry) {
      this._navigationEntry = {
        name: "navigationEntry",
        Name: "NavigationEntry",
        number: 13,
        protoType: 11,
        protoName: "navigation_entry",
        type: dcei_wildsky_common_proto.PageNavigationEntry,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._navigationEntry;
  }
  get dependentSystem() {
    if (!this._dependentSystem) {
      this._dependentSystem = {
        name: "dependentSystem",
        Name: "DependentSystem",
        number: 14,
        protoType: 9,
        protoName: "dependent_system",
        type: JsonToString,
        options: {
          comments: "Enter system name here so the quest will be hiden if the system is locked Names must match with ones in SystemUnlockProgress.lua.txt",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dependentSystem;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.description,
        this.startProgress,
        this.progressTotal,
        this.event,
        this.presentIfRewarded,
        this.filter,
        this.rewardItems,
        this.eventAttributes,
        this.navigationEntry,
        this.dependentSystem,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDescription",
        Name: "DummyOneofForDescription",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStartProgress",
        Name: "DummyOneofForStartProgress",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForProgressTotal",
        Name: "DummyOneofForProgressTotal",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEvent",
        Name: "DummyOneofForEvent",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPresentIfRewarded",
        Name: "DummyOneofForPresentIfRewarded",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFilter",
        Name: "DummyOneofForFilter",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForNavigationEntry",
        Name: "DummyOneofForNavigationEntry",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDependentSystem",
        Name: "DummyOneofForDependentSystem",
        fields: [
          this.fields[10],
        ],
      });
    }
    return this._oneofs;
  }
}
AchievementDefinition.descriptor = new AchievementDefinition_Descriptor();
export class QuestData {
  get descriptor() {
    return QuestData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDailyRefreshTime = false;
    this._dailyRefreshTime = null;
    this._dailyQuestList = [];
    this._dailyPointChests = [];
    this._weeklyPointChests = [];
    this._hasWeeklyRefreshDay = false;
    this._weeklyRefreshDay = null;
  }
  isEmpty() {
    if (this._hasDailyRefreshTime) return false;
    if (this._dailyQuestList.length > 0) return false;
    if (this._dailyPointChests.length > 0) return false;
    if (this._weeklyPointChests.length > 0) return false;
    if (this._hasWeeklyRefreshDay) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof QuestData) {
      return value;
    }
    return QuestData.fromJson(value);
  }
  static fromJson(json) {
    const result = new QuestData();
    if (json.dailyRefreshTime != null) {
      result._hasDailyRefreshTime = true;
      result._dailyRefreshTime = JsonToInt32.fromJson(json.dailyRefreshTime);
    }
    result._dailyQuestList = JsonToList(json.dailyQuestList, QuestDefinition);
    result._dailyPointChests = JsonToList(json.dailyPointChests, QuestActivePointChest);
    result._weeklyPointChests = JsonToList(json.weeklyPointChests, QuestActivePointChest);
    if (json.weeklyRefreshDay != null) {
      result._hasWeeklyRefreshDay = true;
      result._weeklyRefreshDay = JsonToString.fromJson(json.weeklyRefreshDay);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDailyRefreshTime) {
      result.dailyRefreshTime = JsonToInt32.toJson(this._dailyRefreshTime);
    }
    if (this._dailyQuestList.length > 0) {
      result.dailyQuestList = ArrayToJson(this._dailyQuestList, QuestDefinition);
    }
    if (this._dailyPointChests.length > 0) {
      result.dailyPointChests = ArrayToJson(this._dailyPointChests, QuestActivePointChest);
    }
    if (this._weeklyPointChests.length > 0) {
      result.weeklyPointChests = ArrayToJson(this._weeklyPointChests, QuestActivePointChest);
    }
    if (this._hasWeeklyRefreshDay) {
      result.weeklyRefreshDay = JsonToString.toJson(this._weeklyRefreshDay);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get dailyRefreshTime() {
    return this._hasDailyRefreshTime ? this._dailyRefreshTime : JsonToInt32.default;
  }
  get hasDailyRefreshTime() {
    return this._hasDailyRefreshTime;
  }
  setDailyRefreshTime(path, value) {
    return {type: 'SET', path: path.concat(['dailyRefreshTime']), value};
  }
  deleteDailyRefreshTime(path) {
    return {type: 'DELETE', path: path.concat(['dailyRefreshTime'])};
  }
  /**
   * @returns {QuestDefinition[]}
   */
  get dailyQuestList() {
    return this._dailyQuestList;
  }
  addDailyQuestList(path, value) {
    return {type: 'ADD', path: path.concat(['dailyQuestList']), value: value.toJson()};
  }
  setDailyQuestList(path, value) {
    return {type: 'SET', path: path.concat(['dailyQuestList']), value: ArrayToJson(value, QuestDefinition)};
  }
  setDailyQuestListByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['dailyQuestList', key]), value: value.toJson()};
  }
  deleteDailyQuestList(path) {
    return {type: 'DELETE', path: path.concat(['dailyQuestList'])};
  }
  deleteDailyQuestListByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['dailyQuestList', key])};
  }
  /**
   * @returns {QuestActivePointChest[]}
   */
  get dailyPointChests() {
    return this._dailyPointChests;
  }
  addDailyPointChests(path, value) {
    return {type: 'ADD', path: path.concat(['dailyPointChests']), value: value.toJson()};
  }
  setDailyPointChests(path, value) {
    return {type: 'SET', path: path.concat(['dailyPointChests']), value: ArrayToJson(value, QuestActivePointChest)};
  }
  setDailyPointChestsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['dailyPointChests', key]), value: value.toJson()};
  }
  deleteDailyPointChests(path) {
    return {type: 'DELETE', path: path.concat(['dailyPointChests'])};
  }
  deleteDailyPointChestsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['dailyPointChests', key])};
  }
  /**
   * @returns {QuestActivePointChest[]}
   */
  get weeklyPointChests() {
    return this._weeklyPointChests;
  }
  addWeeklyPointChests(path, value) {
    return {type: 'ADD', path: path.concat(['weeklyPointChests']), value: value.toJson()};
  }
  setWeeklyPointChests(path, value) {
    return {type: 'SET', path: path.concat(['weeklyPointChests']), value: ArrayToJson(value, QuestActivePointChest)};
  }
  setWeeklyPointChestsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['weeklyPointChests', key]), value: value.toJson()};
  }
  deleteWeeklyPointChests(path) {
    return {type: 'DELETE', path: path.concat(['weeklyPointChests'])};
  }
  deleteWeeklyPointChestsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['weeklyPointChests', key])};
  }
  /**
   * @returns {string}
   */
  get weeklyRefreshDay() {
    return this._hasWeeklyRefreshDay ? this._weeklyRefreshDay : JsonToString.default;
  }
  get hasWeeklyRefreshDay() {
    return this._hasWeeklyRefreshDay;
  }
  setWeeklyRefreshDay(path, value) {
    return {type: 'SET', path: path.concat(['weeklyRefreshDay']), value};
  }
  deleteWeeklyRefreshDay(path) {
    return {type: 'DELETE', path: path.concat(['weeklyRefreshDay'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "dailyRefreshTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestData(this);
              copy._hasDailyRefreshTime = true;
              copy._dailyRefreshTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDailyRefreshTime) {
                return this;
              }
              const copy = new QuestData(this);
              copy._hasDailyRefreshTime = false;
              copy._dailyRefreshTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "dailyQuestList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestData(this);
              copy._dailyQuestList = [];        for (let i of value) {
                copy._dailyQuestList.push(QuestDefinition.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new QuestData(this);
              copy._dailyQuestList = copy._dailyQuestList.concat([QuestDefinition.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._dailyQuestList.length === 0) {
                return this;
              }
              const copy = new QuestData(this);
              copy._dailyQuestList = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._dailyQuestList.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new QuestData(this);
              copy._dailyQuestList = copy._dailyQuestList.slice();
              copy._dailyQuestList[path[1]] = QuestDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new QuestData(this);
              copy._dailyQuestList = copy._dailyQuestList.slice(0, path[1]).concat(copy._dailyQuestList.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._dailyQuestList.length) {
            return this;
          }
          const oldValue = this._dailyQuestList[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new QuestData(this);
          copy._dailyQuestList = copy._dailyQuestList.slice();
          copy._dailyQuestList[key] = newValue;
          return copy;
        }
      }
      case "dailyPointChests": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestData(this);
              copy._dailyPointChests = [];        for (let i of value) {
                copy._dailyPointChests.push(QuestActivePointChest.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new QuestData(this);
              copy._dailyPointChests = copy._dailyPointChests.concat([QuestActivePointChest.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._dailyPointChests.length === 0) {
                return this;
              }
              const copy = new QuestData(this);
              copy._dailyPointChests = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._dailyPointChests.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new QuestData(this);
              copy._dailyPointChests = copy._dailyPointChests.slice();
              copy._dailyPointChests[path[1]] = QuestActivePointChest.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new QuestData(this);
              copy._dailyPointChests = copy._dailyPointChests.slice(0, path[1]).concat(copy._dailyPointChests.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._dailyPointChests.length) {
            return this;
          }
          const oldValue = this._dailyPointChests[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new QuestData(this);
          copy._dailyPointChests = copy._dailyPointChests.slice();
          copy._dailyPointChests[key] = newValue;
          return copy;
        }
      }
      case "weeklyPointChests": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestData(this);
              copy._weeklyPointChests = [];        for (let i of value) {
                copy._weeklyPointChests.push(QuestActivePointChest.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new QuestData(this);
              copy._weeklyPointChests = copy._weeklyPointChests.concat([QuestActivePointChest.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._weeklyPointChests.length === 0) {
                return this;
              }
              const copy = new QuestData(this);
              copy._weeklyPointChests = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._weeklyPointChests.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new QuestData(this);
              copy._weeklyPointChests = copy._weeklyPointChests.slice();
              copy._weeklyPointChests[path[1]] = QuestActivePointChest.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new QuestData(this);
              copy._weeklyPointChests = copy._weeklyPointChests.slice(0, path[1]).concat(copy._weeklyPointChests.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._weeklyPointChests.length) {
            return this;
          }
          const oldValue = this._weeklyPointChests[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new QuestData(this);
          copy._weeklyPointChests = copy._weeklyPointChests.slice();
          copy._weeklyPointChests[key] = newValue;
          return copy;
        }
      }
      case "weeklyRefreshDay": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestData(this);
              copy._hasWeeklyRefreshDay = true;
              copy._weeklyRefreshDay = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasWeeklyRefreshDay) {
                return this;
              }
              const copy = new QuestData(this);
              copy._hasWeeklyRefreshDay = false;
              copy._weeklyRefreshDay = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {QuestData} other
   * @returns {QuestData}
   */
  merge(other) {
    const copy = new QuestData(this);
    if (other._hasDailyRefreshTime) {
      copy._hasDailyRefreshTime = true;
      copy._dailyRefreshTime = other._dailyRefreshTime;
    }
    copy._dailyQuestList = this._dailyQuestList.concat(other._dailyQuestList);
    copy._dailyPointChests = this._dailyPointChests.concat(other._dailyPointChests);
    copy._weeklyPointChests = this._weeklyPointChests.concat(other._weeklyPointChests);
    if (other._hasWeeklyRefreshDay) {
      copy._hasWeeklyRefreshDay = true;
      copy._weeklyRefreshDay = other._weeklyRefreshDay;
    }
    return copy;
  }
}
QuestData.default = new QuestData();
class QuestData_Builder {
  constructor(value) {
    this._value = new QuestData(value);
  }
  build() {
    return new QuestData(this._value);
  }
  setDailyRefreshTime(value) {
    this._value._hasDailyRefreshTime = true;
    this._value._dailyRefreshTime = value;
    return this;
  }
  deleteDailyRefreshTime() {
    this._value._hasDailyRefreshTime = false;
    this._value._dailyRefreshTime = null;
    return this;
  }
  addAllDailyQuestList(values) {
    this._value._dailyQuestList = this._value._dailyQuestList.concat(values);
    return this;
  }
  addDailyQuestList(value) {
    this._value._dailyQuestList = this._value._dailyQuestList.concat([value]);
    return this;
  }
  setDailyQuestList(index, value) {
    this._value._dailyQuestList = this._value._dailyQuestList.concat();
    this._value._dailyQuestList[index] = value;
    return this;
  }
  clearDailyQuestList() {
    this._value._dailyQuestList = [];
    return this;
  }
  addAllDailyPointChests(values) {
    this._value._dailyPointChests = this._value._dailyPointChests.concat(values);
    return this;
  }
  addDailyPointChests(value) {
    this._value._dailyPointChests = this._value._dailyPointChests.concat([value]);
    return this;
  }
  setDailyPointChests(index, value) {
    this._value._dailyPointChests = this._value._dailyPointChests.concat();
    this._value._dailyPointChests[index] = value;
    return this;
  }
  clearDailyPointChests() {
    this._value._dailyPointChests = [];
    return this;
  }
  addAllWeeklyPointChests(values) {
    this._value._weeklyPointChests = this._value._weeklyPointChests.concat(values);
    return this;
  }
  addWeeklyPointChests(value) {
    this._value._weeklyPointChests = this._value._weeklyPointChests.concat([value]);
    return this;
  }
  setWeeklyPointChests(index, value) {
    this._value._weeklyPointChests = this._value._weeklyPointChests.concat();
    this._value._weeklyPointChests[index] = value;
    return this;
  }
  clearWeeklyPointChests() {
    this._value._weeklyPointChests = [];
    return this;
  }
  setWeeklyRefreshDay(value) {
    this._value._hasWeeklyRefreshDay = true;
    this._value._weeklyRefreshDay = value;
    return this;
  }
  deleteWeeklyRefreshDay() {
    this._value._hasWeeklyRefreshDay = false;
    this._value._weeklyRefreshDay = null;
    return this;
  }
}
QuestData.Builder = QuestData_Builder;
class QuestData_WithParent {
  /**
   * @param {QuestData} value
   * @param {QuestData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return QuestData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDailyRefreshTime() {
    if (this._cachedHasDailyRefreshTime === undefined) {
      if (this._value.hasDailyRefreshTime) {
        this._cachedHasDailyRefreshTime = true;
      } else {
        this._cachedHasDailyRefreshTime = this._parent ? this._parent.hasDailyRefreshTime : false;
      }
    }
    return this._cachedHasDailyRefreshTime;
  }
  get dailyRefreshTime() {
    if (this._cachedDailyRefreshTime === undefined) {
      if (this._value.hasDailyRefreshTime) {
        this._cachedDailyRefreshTime = this._value.dailyRefreshTime;
      } else {
        this._cachedDailyRefreshTime = this._parent ? this._parent.dailyRefreshTime : this._value.dailyRefreshTime;
      }
    }
    return this._cachedDailyRefreshTime;
  }
  get selfDailyQuestList() {
    if (!this._selfDailyQuestList) {
      this._selfDailyQuestList = [];
      for (let i of this._value.dailyQuestList) {
        this._selfDailyQuestList.push(new QuestDefinition.WithParent(i, null));
      }
    }
    return this._selfDailyQuestList;
  }
  get inherentDailyQuestList() {
    if (!this._inherentDailyQuestList) {
      this._inherentDailyQuestList = this._parent ? this._parent.dailyQuestList : [];
    }
    return this._inherentDailyQuestList;
  }
  get dailyQuestList() {
    if (!this._allDailyQuestList) {
      this._allDailyQuestList = this._parent ? this._parent.dailyQuestList.concat(this.selfDailyQuestList) : this.selfDailyQuestList;
    }
    return this._allDailyQuestList;
  }
  get selfDailyPointChests() {
    if (!this._selfDailyPointChests) {
      this._selfDailyPointChests = [];
      for (let i of this._value.dailyPointChests) {
        this._selfDailyPointChests.push(new QuestActivePointChest.WithParent(i, null));
      }
    }
    return this._selfDailyPointChests;
  }
  get inherentDailyPointChests() {
    if (!this._inherentDailyPointChests) {
      this._inherentDailyPointChests = this._parent ? this._parent.dailyPointChests : [];
    }
    return this._inherentDailyPointChests;
  }
  get dailyPointChests() {
    if (!this._allDailyPointChests) {
      this._allDailyPointChests = this._parent ? this._parent.dailyPointChests.concat(this.selfDailyPointChests) : this.selfDailyPointChests;
    }
    return this._allDailyPointChests;
  }
  get selfWeeklyPointChests() {
    if (!this._selfWeeklyPointChests) {
      this._selfWeeklyPointChests = [];
      for (let i of this._value.weeklyPointChests) {
        this._selfWeeklyPointChests.push(new QuestActivePointChest.WithParent(i, null));
      }
    }
    return this._selfWeeklyPointChests;
  }
  get inherentWeeklyPointChests() {
    if (!this._inherentWeeklyPointChests) {
      this._inherentWeeklyPointChests = this._parent ? this._parent.weeklyPointChests : [];
    }
    return this._inherentWeeklyPointChests;
  }
  get weeklyPointChests() {
    if (!this._allWeeklyPointChests) {
      this._allWeeklyPointChests = this._parent ? this._parent.weeklyPointChests.concat(this.selfWeeklyPointChests) : this.selfWeeklyPointChests;
    }
    return this._allWeeklyPointChests;
  }
  get hasWeeklyRefreshDay() {
    if (this._cachedHasWeeklyRefreshDay === undefined) {
      if (this._value.hasWeeklyRefreshDay) {
        this._cachedHasWeeklyRefreshDay = true;
      } else {
        this._cachedHasWeeklyRefreshDay = this._parent ? this._parent.hasWeeklyRefreshDay : false;
      }
    }
    return this._cachedHasWeeklyRefreshDay;
  }
  get weeklyRefreshDay() {
    if (this._cachedWeeklyRefreshDay === undefined) {
      if (this._value.hasWeeklyRefreshDay) {
        this._cachedWeeklyRefreshDay = this._value.weeklyRefreshDay;
      } else {
        this._cachedWeeklyRefreshDay = this._parent ? this._parent.weeklyRefreshDay : this._value.weeklyRefreshDay;
      }
    }
    return this._cachedWeeklyRefreshDay;
  }
  update(current, parent) {
    const result = new QuestData_WithParent(current, parent);
    if (this._selfDailyQuestList) {
      if (this._value.dailyQuestList === current.dailyQuestList) {
        result._selfDailyQuestList = this._selfDailyQuestList;
      } else {
        result._selfDailyQuestList = [];
        for (let i = 0; i < current.dailyQuestList.length; i++) {
          const oldValue = this._value.dailyQuestList[i];
          if (oldValue) {
            const oldCache = this._selfDailyQuestList[i];
            if (oldValue === current.dailyQuestList[i]) {
              result._selfDailyQuestList[i] = oldCache;
            } else {
              result._selfDailyQuestList[i] = oldCache.update(current.dailyQuestList[i], null);
            }
          } else {
            result._selfDailyQuestList[i] = new QuestDefinition.WithParent(current.dailyQuestList[i], null);
          }
        }
      }
    }
    if (this._selfDailyPointChests) {
      if (this._value.dailyPointChests === current.dailyPointChests) {
        result._selfDailyPointChests = this._selfDailyPointChests;
      } else {
        result._selfDailyPointChests = [];
        for (let i = 0; i < current.dailyPointChests.length; i++) {
          const oldValue = this._value.dailyPointChests[i];
          if (oldValue) {
            const oldCache = this._selfDailyPointChests[i];
            if (oldValue === current.dailyPointChests[i]) {
              result._selfDailyPointChests[i] = oldCache;
            } else {
              result._selfDailyPointChests[i] = oldCache.update(current.dailyPointChests[i], null);
            }
          } else {
            result._selfDailyPointChests[i] = new QuestActivePointChest.WithParent(current.dailyPointChests[i], null);
          }
        }
      }
    }
    if (this._selfWeeklyPointChests) {
      if (this._value.weeklyPointChests === current.weeklyPointChests) {
        result._selfWeeklyPointChests = this._selfWeeklyPointChests;
      } else {
        result._selfWeeklyPointChests = [];
        for (let i = 0; i < current.weeklyPointChests.length; i++) {
          const oldValue = this._value.weeklyPointChests[i];
          if (oldValue) {
            const oldCache = this._selfWeeklyPointChests[i];
            if (oldValue === current.weeklyPointChests[i]) {
              result._selfWeeklyPointChests[i] = oldCache;
            } else {
              result._selfWeeklyPointChests[i] = oldCache.update(current.weeklyPointChests[i], null);
            }
          } else {
            result._selfWeeklyPointChests[i] = new QuestActivePointChest.WithParent(current.weeklyPointChests[i], null);
          }
        }
      }
    }
    return result;
  }
}
QuestData_WithParent.default = new QuestData_WithParent(QuestData.default, null);
QuestData.WithParent = QuestData_WithParent;
class QuestData_Descriptor {
  get dailyRefreshTime() {
    if (!this._dailyRefreshTime) {
      this._dailyRefreshTime = {
        name: "dailyRefreshTime",
        Name: "DailyRefreshTime",
        number: 1,
        protoType: 5,
        protoName: "daily_refresh_time",
        type: JsonToInt32,
        options: {
          comments: "Time in seconds passed from midnight",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dailyRefreshTime;
  }
  get dailyQuestList() {
    if (!this._dailyQuestList) {
      this._dailyQuestList = {
        name: "dailyQuestList",
        Name: "DailyQuestList",
        number: 2,
        protoType: 11,
        protoName: "daily_quest_list",
        type: QuestDefinition,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dailyQuestList;
  }
  get dailyPointChests() {
    if (!this._dailyPointChests) {
      this._dailyPointChests = {
        name: "dailyPointChests",
        Name: "DailyPointChests",
        number: 3,
        protoType: 11,
        protoName: "daily_point_chests",
        type: QuestActivePointChest,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dailyPointChests;
  }
  get weeklyPointChests() {
    if (!this._weeklyPointChests) {
      this._weeklyPointChests = {
        name: "weeklyPointChests",
        Name: "WeeklyPointChests",
        number: 4,
        protoType: 11,
        protoName: "weekly_point_chests",
        type: QuestActivePointChest,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._weeklyPointChests;
  }
  get weeklyRefreshDay() {
    if (!this._weeklyRefreshDay) {
      this._weeklyRefreshDay = {
        name: "weeklyRefreshDay",
        Name: "WeeklyRefreshDay",
        number: 5,
        protoType: 9,
        protoName: "weekly_refresh_day",
        type: JsonToString,
        options: {
          valueDropdown: "DailyQuestOpenDaysStringList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._weeklyRefreshDay;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.dailyRefreshTime,
        this.dailyQuestList,
        this.dailyPointChests,
        this.weeklyPointChests,
        this.weeklyRefreshDay,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDailyRefreshTime",
        Name: "DummyOneofForDailyRefreshTime",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForWeeklyRefreshDay",
        Name: "DummyOneofForWeeklyRefreshDay",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
QuestData.descriptor = new QuestData_Descriptor();
class TimedQuestData_QuestDay {
  get descriptor() {
    return TimedQuestData_QuestDay.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._questList = [];
  }
  isEmpty() {
    if (this._questList.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TimedQuestData_QuestDay) {
      return value;
    }
    return TimedQuestData_QuestDay.fromJson(value);
  }
  static fromJson(json) {
    const result = new TimedQuestData_QuestDay();
    result._questList = JsonToList(json.questList, QuestDefinition);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._questList.length > 0) {
      result.questList = ArrayToJson(this._questList, QuestDefinition);
    }
    return result;
  }
  /**
   * @returns {QuestDefinition[]}
   */
  get questList() {
    return this._questList;
  }
  addQuestList(path, value) {
    return {type: 'ADD', path: path.concat(['questList']), value: value.toJson()};
  }
  setQuestList(path, value) {
    return {type: 'SET', path: path.concat(['questList']), value: ArrayToJson(value, QuestDefinition)};
  }
  setQuestListByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['questList', key]), value: value.toJson()};
  }
  deleteQuestList(path) {
    return {type: 'DELETE', path: path.concat(['questList'])};
  }
  deleteQuestListByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['questList', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "questList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TimedQuestData_QuestDay(this);
              copy._questList = [];        for (let i of value) {
                copy._questList.push(QuestDefinition.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TimedQuestData_QuestDay(this);
              copy._questList = copy._questList.concat([QuestDefinition.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._questList.length === 0) {
                return this;
              }
              const copy = new TimedQuestData_QuestDay(this);
              copy._questList = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._questList.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TimedQuestData_QuestDay(this);
              copy._questList = copy._questList.slice();
              copy._questList[path[1]] = QuestDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TimedQuestData_QuestDay(this);
              copy._questList = copy._questList.slice(0, path[1]).concat(copy._questList.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._questList.length) {
            return this;
          }
          const oldValue = this._questList[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TimedQuestData_QuestDay(this);
          copy._questList = copy._questList.slice();
          copy._questList[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TimedQuestData_QuestDay} other
   * @returns {TimedQuestData_QuestDay}
   */
  merge(other) {
    const copy = new TimedQuestData_QuestDay(this);
    copy._questList = this._questList.concat(other._questList);
    return copy;
  }
}
TimedQuestData_QuestDay.default = new TimedQuestData_QuestDay();
class TimedQuestData_QuestDay_Builder {
  constructor(value) {
    this._value = new TimedQuestData_QuestDay(value);
  }
  build() {
    return new TimedQuestData_QuestDay(this._value);
  }
  addAllQuestList(values) {
    this._value._questList = this._value._questList.concat(values);
    return this;
  }
  addQuestList(value) {
    this._value._questList = this._value._questList.concat([value]);
    return this;
  }
  setQuestList(index, value) {
    this._value._questList = this._value._questList.concat();
    this._value._questList[index] = value;
    return this;
  }
  clearQuestList() {
    this._value._questList = [];
    return this;
  }
}
TimedQuestData_QuestDay.Builder = TimedQuestData_QuestDay_Builder;
class TimedQuestData_QuestDay_WithParent {
  /**
   * @param {TimedQuestData_QuestDay} value
   * @param {TimedQuestData_QuestDay_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TimedQuestData_QuestDay.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfQuestList() {
    if (!this._selfQuestList) {
      this._selfQuestList = [];
      for (let i of this._value.questList) {
        this._selfQuestList.push(new QuestDefinition.WithParent(i, null));
      }
    }
    return this._selfQuestList;
  }
  get inherentQuestList() {
    if (!this._inherentQuestList) {
      this._inherentQuestList = this._parent ? this._parent.questList : [];
    }
    return this._inherentQuestList;
  }
  get questList() {
    if (!this._allQuestList) {
      this._allQuestList = this._parent ? this._parent.questList.concat(this.selfQuestList) : this.selfQuestList;
    }
    return this._allQuestList;
  }
  update(current, parent) {
    const result = new TimedQuestData_QuestDay_WithParent(current, parent);
    if (this._selfQuestList) {
      if (this._value.questList === current.questList) {
        result._selfQuestList = this._selfQuestList;
      } else {
        result._selfQuestList = [];
        for (let i = 0; i < current.questList.length; i++) {
          const oldValue = this._value.questList[i];
          if (oldValue) {
            const oldCache = this._selfQuestList[i];
            if (oldValue === current.questList[i]) {
              result._selfQuestList[i] = oldCache;
            } else {
              result._selfQuestList[i] = oldCache.update(current.questList[i], null);
            }
          } else {
            result._selfQuestList[i] = new QuestDefinition.WithParent(current.questList[i], null);
          }
        }
      }
    }
    return result;
  }
}
TimedQuestData_QuestDay_WithParent.default = new TimedQuestData_QuestDay_WithParent(TimedQuestData_QuestDay.default, null);
TimedQuestData_QuestDay.WithParent = TimedQuestData_QuestDay_WithParent;
class TimedQuestData_QuestDay_Descriptor {
  get questList() {
    if (!this._questList) {
      this._questList = {
        name: "questList",
        Name: "QuestList",
        number: 2,
        protoType: 11,
        protoName: "quest_list",
        type: QuestDefinition,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._questList;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.questList,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
TimedQuestData_QuestDay.descriptor = new TimedQuestData_QuestDay_Descriptor();
export class TimedQuestData {
  get descriptor() {
    return TimedQuestData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDailyRefreshTime = false;
    this._dailyRefreshTime = null;
    this._hasTotalTime = false;
    this._totalTime = null;
    this._hasEnableFilter = false;
    this._enableFilter = null;
    this._questDays = [];
  }
  isEmpty() {
    if (this._hasDailyRefreshTime) return false;
    if (this._hasTotalTime) return false;
    if (this._hasEnableFilter && !this._enableFilter.isEmpty()) return false;
    if (this._questDays.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TimedQuestData) {
      return value;
    }
    return TimedQuestData.fromJson(value);
  }
  static fromJson(json) {
    const result = new TimedQuestData();
    if (json.dailyRefreshTime != null) {
      result._hasDailyRefreshTime = true;
      result._dailyRefreshTime = JsonToInt32.fromJson(json.dailyRefreshTime);
    }
    if (json.totalTime != null) {
      result._hasTotalTime = true;
      result._totalTime = JsonToInt32.fromJson(json.totalTime);
    }
    if (json.enableFilter != null) {
      result._hasEnableFilter = true;
      result._enableFilter = Filter.fromJson(json.enableFilter);
    }
    result._questDays = JsonToList(json.questDays, TimedQuestData_QuestDay);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDailyRefreshTime) {
      result.dailyRefreshTime = JsonToInt32.toJson(this._dailyRefreshTime);
    }
    if (this._hasTotalTime) {
      result.totalTime = JsonToInt32.toJson(this._totalTime);
    }
    if (this._hasEnableFilter && !this._enableFilter.isEmpty()) {
      result.enableFilter = Filter.toJson(this._enableFilter);
    }
    if (this._questDays.length > 0) {
      result.questDays = ArrayToJson(this._questDays, TimedQuestData_QuestDay);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get dailyRefreshTime() {
    return this._hasDailyRefreshTime ? this._dailyRefreshTime : JsonToInt32.default;
  }
  get hasDailyRefreshTime() {
    return this._hasDailyRefreshTime;
  }
  setDailyRefreshTime(path, value) {
    return {type: 'SET', path: path.concat(['dailyRefreshTime']), value};
  }
  deleteDailyRefreshTime(path) {
    return {type: 'DELETE', path: path.concat(['dailyRefreshTime'])};
  }
  /**
   * @returns {number}
   */
  get totalTime() {
    return this._hasTotalTime ? this._totalTime : JsonToInt32.default;
  }
  get hasTotalTime() {
    return this._hasTotalTime;
  }
  setTotalTime(path, value) {
    return {type: 'SET', path: path.concat(['totalTime']), value};
  }
  deleteTotalTime(path) {
    return {type: 'DELETE', path: path.concat(['totalTime'])};
  }
  /**
   * @returns {Filter}
   */
  get enableFilter() {
    return this._hasEnableFilter ? this._enableFilter : Filter.default;
  }
  get hasEnableFilter() {
    return this._hasEnableFilter;
  }
  setEnableFilter(path, value) {
    return {type: 'SET', path: path.concat(['enableFilter']), value: value.toJson()};
  }
  deleteEnableFilter(path) {
    return {type: 'DELETE', path: path.concat(['enableFilter'])};
  }
  /**
   * @returns {TimedQuestData_QuestDay[]}
   */
  get questDays() {
    return this._questDays;
  }
  addQuestDays(path, value) {
    return {type: 'ADD', path: path.concat(['questDays']), value: value.toJson()};
  }
  setQuestDays(path, value) {
    return {type: 'SET', path: path.concat(['questDays']), value: ArrayToJson(value, TimedQuestData_QuestDay)};
  }
  setQuestDaysByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['questDays', key]), value: value.toJson()};
  }
  deleteQuestDays(path) {
    return {type: 'DELETE', path: path.concat(['questDays'])};
  }
  deleteQuestDaysByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['questDays', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "dailyRefreshTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TimedQuestData(this);
              copy._hasDailyRefreshTime = true;
              copy._dailyRefreshTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDailyRefreshTime) {
                return this;
              }
              const copy = new TimedQuestData(this);
              copy._hasDailyRefreshTime = false;
              copy._dailyRefreshTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "totalTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TimedQuestData(this);
              copy._hasTotalTime = true;
              copy._totalTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTotalTime) {
                return this;
              }
              const copy = new TimedQuestData(this);
              copy._hasTotalTime = false;
              copy._totalTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "enableFilter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TimedQuestData(this);
              copy._hasEnableFilter = true;
              copy._enableFilter = Filter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEnableFilter) {
                return this;
              }
              const copy = new TimedQuestData(this);
              copy._hasEnableFilter = false;
              copy._enableFilter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasEnableFilter) {
            const copy = new TimedQuestData(this);
            copy._hasEnableFilter = true;
            copy._enableFilter = Filter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._enableFilter.apply(type, path.slice(1), value);
          if (newValue === this._enableFilter) {
            return this;
          }
          const copy = new TimedQuestData(this);
          copy._enableFilter = copy._enableFilter.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "questDays": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TimedQuestData(this);
              copy._questDays = [];        for (let i of value) {
                copy._questDays.push(TimedQuestData_QuestDay.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TimedQuestData(this);
              copy._questDays = copy._questDays.concat([TimedQuestData_QuestDay.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._questDays.length === 0) {
                return this;
              }
              const copy = new TimedQuestData(this);
              copy._questDays = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._questDays.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TimedQuestData(this);
              copy._questDays = copy._questDays.slice();
              copy._questDays[path[1]] = TimedQuestData_QuestDay.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TimedQuestData(this);
              copy._questDays = copy._questDays.slice(0, path[1]).concat(copy._questDays.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._questDays.length) {
            return this;
          }
          const oldValue = this._questDays[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TimedQuestData(this);
          copy._questDays = copy._questDays.slice();
          copy._questDays[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TimedQuestData} other
   * @returns {TimedQuestData}
   */
  merge(other) {
    const copy = new TimedQuestData(this);
    if (other._hasDailyRefreshTime) {
      copy._hasDailyRefreshTime = true;
      copy._dailyRefreshTime = other._dailyRefreshTime;
    }
    if (other._hasTotalTime) {
      copy._hasTotalTime = true;
      copy._totalTime = other._totalTime;
    }
    if (other._hasEnableFilter) {
      if (copy._hasEnableFilter) {
        copy._enableFilter = copy.enableFilter.merge(other.enableFilter);
      } else {
        copy._enableFilter = other._enableFilter;
      }
      copy._hasEnableFilter = true;
    }
    copy._questDays = this._questDays.concat(other._questDays);
    return copy;
  }
}
TimedQuestData.default = new TimedQuestData();
TimedQuestData.QuestDay = TimedQuestData_QuestDay;
class TimedQuestData_Builder {
  constructor(value) {
    this._value = new TimedQuestData(value);
  }
  build() {
    return new TimedQuestData(this._value);
  }
  setDailyRefreshTime(value) {
    this._value._hasDailyRefreshTime = true;
    this._value._dailyRefreshTime = value;
    return this;
  }
  deleteDailyRefreshTime() {
    this._value._hasDailyRefreshTime = false;
    this._value._dailyRefreshTime = null;
    return this;
  }
  setTotalTime(value) {
    this._value._hasTotalTime = true;
    this._value._totalTime = value;
    return this;
  }
  deleteTotalTime() {
    this._value._hasTotalTime = false;
    this._value._totalTime = null;
    return this;
  }
  setEnableFilter(value) {
    this._value._hasEnableFilter = true;
    this._value._enableFilter = value;
    return this;
  }
  deleteEnableFilter() {
    this._value._hasEnableFilter = false;
    this._value._enableFilter = null;
    return this;
  }
  addAllQuestDays(values) {
    this._value._questDays = this._value._questDays.concat(values);
    return this;
  }
  addQuestDays(value) {
    this._value._questDays = this._value._questDays.concat([value]);
    return this;
  }
  setQuestDays(index, value) {
    this._value._questDays = this._value._questDays.concat();
    this._value._questDays[index] = value;
    return this;
  }
  clearQuestDays() {
    this._value._questDays = [];
    return this;
  }
}
TimedQuestData.Builder = TimedQuestData_Builder;
class TimedQuestData_WithParent {
  /**
   * @param {TimedQuestData} value
   * @param {TimedQuestData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TimedQuestData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDailyRefreshTime() {
    if (this._cachedHasDailyRefreshTime === undefined) {
      if (this._value.hasDailyRefreshTime) {
        this._cachedHasDailyRefreshTime = true;
      } else {
        this._cachedHasDailyRefreshTime = this._parent ? this._parent.hasDailyRefreshTime : false;
      }
    }
    return this._cachedHasDailyRefreshTime;
  }
  get dailyRefreshTime() {
    if (this._cachedDailyRefreshTime === undefined) {
      if (this._value.hasDailyRefreshTime) {
        this._cachedDailyRefreshTime = this._value.dailyRefreshTime;
      } else {
        this._cachedDailyRefreshTime = this._parent ? this._parent.dailyRefreshTime : this._value.dailyRefreshTime;
      }
    }
    return this._cachedDailyRefreshTime;
  }
  get hasTotalTime() {
    if (this._cachedHasTotalTime === undefined) {
      if (this._value.hasTotalTime) {
        this._cachedHasTotalTime = true;
      } else {
        this._cachedHasTotalTime = this._parent ? this._parent.hasTotalTime : false;
      }
    }
    return this._cachedHasTotalTime;
  }
  get totalTime() {
    if (this._cachedTotalTime === undefined) {
      if (this._value.hasTotalTime) {
        this._cachedTotalTime = this._value.totalTime;
      } else {
        this._cachedTotalTime = this._parent ? this._parent.totalTime : this._value.totalTime;
      }
    }
    return this._cachedTotalTime;
  }
  get hasEnableFilter() {
    if (this._cachedHasEnableFilter === undefined) {
      if (this._value.hasEnableFilter) {
        this._cachedHasEnableFilter = true;
      } else {
        this._cachedHasEnableFilter = this._parent ? this._parent.hasEnableFilter : false;
      }
    }
    return this._cachedHasEnableFilter;
  }
  get enableFilter() {
    if (!this._cachedEnableFilter) {
      if (this._value.hasEnableFilter) {
        this._cachedEnableFilter = new Filter.WithParent(this._value.enableFilter, this._parent && this._parent.hasEnableFilter ? this._parent.enableFilter : null);
      } else {
        this._cachedEnableFilter = this._parent ? new Filter.WithParent(Filter.default, this._parent.enableFilter) : Filter.WithParent.default;
      }
    }
    return this._cachedEnableFilter;
  }
  get selfQuestDays() {
    if (!this._selfQuestDays) {
      this._selfQuestDays = [];
      for (let i of this._value.questDays) {
        this._selfQuestDays.push(new TimedQuestData_QuestDay.WithParent(i, null));
      }
    }
    return this._selfQuestDays;
  }
  get inherentQuestDays() {
    if (!this._inherentQuestDays) {
      this._inherentQuestDays = this._parent ? this._parent.questDays : [];
    }
    return this._inherentQuestDays;
  }
  get questDays() {
    if (!this._allQuestDays) {
      this._allQuestDays = this._parent ? this._parent.questDays.concat(this.selfQuestDays) : this.selfQuestDays;
    }
    return this._allQuestDays;
  }
  update(current, parent) {
    const result = new TimedQuestData_WithParent(current, parent);
    if (this._cachedEnableFilter && this._value.hasEnableFilter && current.hasEnableFilter) {
      if (this._value.enableFilter === current.enableFilter && this._parent === parent) {
        result._cachedEnableFilter = this._cachedEnableFilter;
      } else {
        result._cachedEnableFilter = this._cachedEnableFilter.update(current.enableFilter, parent && parent.hasEnableFilter ? parent.enableFilter : null);
      }
    }
    if (this._selfQuestDays) {
      if (this._value.questDays === current.questDays) {
        result._selfQuestDays = this._selfQuestDays;
      } else {
        result._selfQuestDays = [];
        for (let i = 0; i < current.questDays.length; i++) {
          const oldValue = this._value.questDays[i];
          if (oldValue) {
            const oldCache = this._selfQuestDays[i];
            if (oldValue === current.questDays[i]) {
              result._selfQuestDays[i] = oldCache;
            } else {
              result._selfQuestDays[i] = oldCache.update(current.questDays[i], null);
            }
          } else {
            result._selfQuestDays[i] = new TimedQuestData_QuestDay.WithParent(current.questDays[i], null);
          }
        }
      }
    }
    return result;
  }
}
TimedQuestData_WithParent.default = new TimedQuestData_WithParent(TimedQuestData.default, null);
TimedQuestData.WithParent = TimedQuestData_WithParent;
class TimedQuestData_Descriptor {
  get dailyRefreshTime() {
    if (!this._dailyRefreshTime) {
      this._dailyRefreshTime = {
        name: "dailyRefreshTime",
        Name: "DailyRefreshTime",
        number: 1,
        protoType: 5,
        protoName: "daily_refresh_time",
        type: JsonToInt32,
        options: {
          comments: "Time in seconds passed from midnight",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dailyRefreshTime;
  }
  get totalTime() {
    if (!this._totalTime) {
      this._totalTime = {
        name: "totalTime",
        Name: "TotalTime",
        number: 2,
        protoType: 5,
        protoName: "total_time",
        type: JsonToInt32,
        options: {
          comments: "Time in seconds passed from midnight",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._totalTime;
  }
  get enableFilter() {
    if (!this._enableFilter) {
      this._enableFilter = {
        name: "enableFilter",
        Name: "EnableFilter",
        number: 3,
        protoType: 11,
        protoName: "enable_filter",
        type: Filter,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._enableFilter;
  }
  get questDays() {
    if (!this._questDays) {
      this._questDays = {
        name: "questDays",
        Name: "QuestDays",
        number: 11,
        protoType: 11,
        protoName: "quest_days",
        type: TimedQuestData_QuestDay,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._questDays;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.dailyRefreshTime,
        this.totalTime,
        this.enableFilter,
        this.questDays,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDailyRefreshTime",
        Name: "DummyOneofForDailyRefreshTime",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTotalTime",
        Name: "DummyOneofForTotalTime",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEnableFilter",
        Name: "DummyOneofForEnableFilter",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
TimedQuestData.descriptor = new TimedQuestData_Descriptor();
export class AchievementData {
  get descriptor() {
    return AchievementData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._achievementList = [];
  }
  isEmpty() {
    if (this._achievementList.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof AchievementData) {
      return value;
    }
    return AchievementData.fromJson(value);
  }
  static fromJson(json) {
    const result = new AchievementData();
    result._achievementList = JsonToList(json.achievementList, AchievementDefinition);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._achievementList.length > 0) {
      result.achievementList = ArrayToJson(this._achievementList, AchievementDefinition);
    }
    return result;
  }
  /**
   * @returns {AchievementDefinition[]}
   */
  get achievementList() {
    return this._achievementList;
  }
  addAchievementList(path, value) {
    return {type: 'ADD', path: path.concat(['achievementList']), value: value.toJson()};
  }
  setAchievementList(path, value) {
    return {type: 'SET', path: path.concat(['achievementList']), value: ArrayToJson(value, AchievementDefinition)};
  }
  setAchievementListByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['achievementList', key]), value: value.toJson()};
  }
  deleteAchievementList(path) {
    return {type: 'DELETE', path: path.concat(['achievementList'])};
  }
  deleteAchievementListByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['achievementList', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "achievementList": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AchievementData(this);
              copy._achievementList = [];        for (let i of value) {
                copy._achievementList.push(AchievementDefinition.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new AchievementData(this);
              copy._achievementList = copy._achievementList.concat([AchievementDefinition.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._achievementList.length === 0) {
                return this;
              }
              const copy = new AchievementData(this);
              copy._achievementList = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._achievementList.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new AchievementData(this);
              copy._achievementList = copy._achievementList.slice();
              copy._achievementList[path[1]] = AchievementDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new AchievementData(this);
              copy._achievementList = copy._achievementList.slice(0, path[1]).concat(copy._achievementList.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._achievementList.length) {
            return this;
          }
          const oldValue = this._achievementList[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new AchievementData(this);
          copy._achievementList = copy._achievementList.slice();
          copy._achievementList[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {AchievementData} other
   * @returns {AchievementData}
   */
  merge(other) {
    const copy = new AchievementData(this);
    copy._achievementList = this._achievementList.concat(other._achievementList);
    return copy;
  }
}
AchievementData.default = new AchievementData();
class AchievementData_Builder {
  constructor(value) {
    this._value = new AchievementData(value);
  }
  build() {
    return new AchievementData(this._value);
  }
  addAllAchievementList(values) {
    this._value._achievementList = this._value._achievementList.concat(values);
    return this;
  }
  addAchievementList(value) {
    this._value._achievementList = this._value._achievementList.concat([value]);
    return this;
  }
  setAchievementList(index, value) {
    this._value._achievementList = this._value._achievementList.concat();
    this._value._achievementList[index] = value;
    return this;
  }
  clearAchievementList() {
    this._value._achievementList = [];
    return this;
  }
}
AchievementData.Builder = AchievementData_Builder;
class AchievementData_WithParent {
  /**
   * @param {AchievementData} value
   * @param {AchievementData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return AchievementData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfAchievementList() {
    if (!this._selfAchievementList) {
      this._selfAchievementList = [];
      for (let i of this._value.achievementList) {
        this._selfAchievementList.push(new AchievementDefinition.WithParent(i, null));
      }
    }
    return this._selfAchievementList;
  }
  get inherentAchievementList() {
    if (!this._inherentAchievementList) {
      this._inherentAchievementList = this._parent ? this._parent.achievementList : [];
    }
    return this._inherentAchievementList;
  }
  get achievementList() {
    if (!this._allAchievementList) {
      this._allAchievementList = this._parent ? this._parent.achievementList.concat(this.selfAchievementList) : this.selfAchievementList;
    }
    return this._allAchievementList;
  }
  update(current, parent) {
    const result = new AchievementData_WithParent(current, parent);
    if (this._selfAchievementList) {
      if (this._value.achievementList === current.achievementList) {
        result._selfAchievementList = this._selfAchievementList;
      } else {
        result._selfAchievementList = [];
        for (let i = 0; i < current.achievementList.length; i++) {
          const oldValue = this._value.achievementList[i];
          if (oldValue) {
            const oldCache = this._selfAchievementList[i];
            if (oldValue === current.achievementList[i]) {
              result._selfAchievementList[i] = oldCache;
            } else {
              result._selfAchievementList[i] = oldCache.update(current.achievementList[i], null);
            }
          } else {
            result._selfAchievementList[i] = new AchievementDefinition.WithParent(current.achievementList[i], null);
          }
        }
      }
    }
    return result;
  }
}
AchievementData_WithParent.default = new AchievementData_WithParent(AchievementData.default, null);
AchievementData.WithParent = AchievementData_WithParent;
class AchievementData_Descriptor {
  get achievementList() {
    if (!this._achievementList) {
      this._achievementList = {
        name: "achievementList",
        Name: "AchievementList",
        number: 1,
        protoType: 11,
        protoName: "achievement_list",
        type: AchievementDefinition,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._achievementList;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.achievementList,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
AchievementData.descriptor = new AchievementData_Descriptor();
export class QuestAndAchievementEvents {
  get descriptor() {
    return QuestAndAchievementEvents.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._eventNames = [];
  }
  isEmpty() {
    if (this._eventNames.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof QuestAndAchievementEvents) {
      return value;
    }
    return QuestAndAchievementEvents.fromJson(value);
  }
  static fromJson(json) {
    const result = new QuestAndAchievementEvents();
    result._eventNames = JsonToList(json.eventNames, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._eventNames.length > 0) {
      result.eventNames = ArrayToJson(this._eventNames, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string[]}
   */
  get eventNames() {
    return this._eventNames;
  }
  addEventNames(path, value) {
    return {type: 'ADD', path: path.concat(['eventNames']), value};
  }
  setEventNames(path, value) {
    return {type: 'SET', path: path.concat(['eventNames']), value: ArrayToJson(value, JsonToString)};
  }
  setEventNamesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['eventNames', key]), value};
  }
  deleteEventNames(path) {
    return {type: 'DELETE', path: path.concat(['eventNames'])};
  }
  deleteEventNamesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['eventNames', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "eventNames": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestAndAchievementEvents(this);
              copy._eventNames = [];        for (let i of value) {
                copy._eventNames.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new QuestAndAchievementEvents(this);
              copy._eventNames = copy._eventNames.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._eventNames.length === 0) {
                return this;
              }
              const copy = new QuestAndAchievementEvents(this);
              copy._eventNames = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._eventNames.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new QuestAndAchievementEvents(this);
              copy._eventNames = copy._eventNames.slice();
              copy._eventNames[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new QuestAndAchievementEvents(this);
              copy._eventNames = copy._eventNames.slice(0, path[1]).concat(copy._eventNames.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._eventNames.length) {
            return this;
          }
          const oldValue = this._eventNames[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new QuestAndAchievementEvents(this);
          copy._eventNames = copy._eventNames.slice();
          copy._eventNames[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {QuestAndAchievementEvents} other
   * @returns {QuestAndAchievementEvents}
   */
  merge(other) {
    const copy = new QuestAndAchievementEvents(this);
    copy._eventNames = this._eventNames.concat(other._eventNames);
    return copy;
  }
}
QuestAndAchievementEvents.default = new QuestAndAchievementEvents();
class QuestAndAchievementEvents_Builder {
  constructor(value) {
    this._value = new QuestAndAchievementEvents(value);
  }
  build() {
    return new QuestAndAchievementEvents(this._value);
  }
  addAllEventNames(values) {
    this._value._eventNames = this._value._eventNames.concat(values);
    return this;
  }
  addEventNames(value) {
    this._value._eventNames = this._value._eventNames.concat([value]);
    return this;
  }
  setEventNames(index, value) {
    this._value._eventNames = this._value._eventNames.concat();
    this._value._eventNames[index] = value;
    return this;
  }
  clearEventNames() {
    this._value._eventNames = [];
    return this;
  }
}
QuestAndAchievementEvents.Builder = QuestAndAchievementEvents_Builder;
class QuestAndAchievementEvents_WithParent {
  /**
   * @param {QuestAndAchievementEvents} value
   * @param {QuestAndAchievementEvents_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return QuestAndAchievementEvents.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfEventNames() {
    return this._value.eventNames;
  }
  get inherentEventNames() {
    if (!this._inherentEventNames) {
      this._inherentEventNames = this._parent ? this._parent.eventNames : [];
    }
    return this._inherentEventNames;
  }
  get eventNames() {
    if (!this._allEventNames) {
      this._allEventNames = this._parent ? this._parent.eventNames.concat(this.selfEventNames) : this.selfEventNames;
    }
    return this._allEventNames;
  }
  update(current, parent) {
    const result = new QuestAndAchievementEvents_WithParent(current, parent);
    return result;
  }
}
QuestAndAchievementEvents_WithParent.default = new QuestAndAchievementEvents_WithParent(QuestAndAchievementEvents.default, null);
QuestAndAchievementEvents.WithParent = QuestAndAchievementEvents_WithParent;
class QuestAndAchievementEvents_Descriptor {
  get eventNames() {
    if (!this._eventNames) {
      this._eventNames = {
        name: "eventNames",
        Name: "EventNames",
        number: 1,
        protoType: 9,
        protoName: "event_names",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventNames;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.eventNames,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
QuestAndAchievementEvents.descriptor = new QuestAndAchievementEvents_Descriptor();
export class QuestAndAchievementData {
  get descriptor() {
    return QuestAndAchievementData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasQuestData = false;
    this._questData = null;
    this._hasAchievementData = false;
    this._achievementData = null;
    this._hasEventNames = false;
    this._eventNames = null;
    this._hasTimedQuestData = false;
    this._timedQuestData = null;
  }
  isEmpty() {
    if (this._hasQuestData && !this._questData.isEmpty()) return false;
    if (this._hasAchievementData && !this._achievementData.isEmpty()) return false;
    if (this._hasEventNames && !this._eventNames.isEmpty()) return false;
    if (this._hasTimedQuestData && !this._timedQuestData.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof QuestAndAchievementData) {
      return value;
    }
    return QuestAndAchievementData.fromJson(value);
  }
  static fromJson(json) {
    const result = new QuestAndAchievementData();
    if (json.questData != null) {
      result._hasQuestData = true;
      result._questData = QuestData.fromJson(json.questData);
    }
    if (json.achievementData != null) {
      result._hasAchievementData = true;
      result._achievementData = AchievementData.fromJson(json.achievementData);
    }
    if (json.eventNames != null) {
      result._hasEventNames = true;
      result._eventNames = QuestAndAchievementEvents.fromJson(json.eventNames);
    }
    if (json.timedQuestData != null) {
      result._hasTimedQuestData = true;
      result._timedQuestData = TimedQuestData.fromJson(json.timedQuestData);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasQuestData && !this._questData.isEmpty()) {
      result.questData = QuestData.toJson(this._questData);
    }
    if (this._hasAchievementData && !this._achievementData.isEmpty()) {
      result.achievementData = AchievementData.toJson(this._achievementData);
    }
    if (this._hasEventNames && !this._eventNames.isEmpty()) {
      result.eventNames = QuestAndAchievementEvents.toJson(this._eventNames);
    }
    if (this._hasTimedQuestData && !this._timedQuestData.isEmpty()) {
      result.timedQuestData = TimedQuestData.toJson(this._timedQuestData);
    }
    return result;
  }
  /**
   * @returns {QuestData}
   */
  get questData() {
    return this._hasQuestData ? this._questData : QuestData.default;
  }
  get hasQuestData() {
    return this._hasQuestData;
  }
  setQuestData(path, value) {
    return {type: 'SET', path: path.concat(['questData']), value: value.toJson()};
  }
  deleteQuestData(path) {
    return {type: 'DELETE', path: path.concat(['questData'])};
  }
  /**
   * @returns {AchievementData}
   */
  get achievementData() {
    return this._hasAchievementData ? this._achievementData : AchievementData.default;
  }
  get hasAchievementData() {
    return this._hasAchievementData;
  }
  setAchievementData(path, value) {
    return {type: 'SET', path: path.concat(['achievementData']), value: value.toJson()};
  }
  deleteAchievementData(path) {
    return {type: 'DELETE', path: path.concat(['achievementData'])};
  }
  /**
   * @returns {QuestAndAchievementEvents}
   */
  get eventNames() {
    return this._hasEventNames ? this._eventNames : QuestAndAchievementEvents.default;
  }
  get hasEventNames() {
    return this._hasEventNames;
  }
  setEventNames(path, value) {
    return {type: 'SET', path: path.concat(['eventNames']), value: value.toJson()};
  }
  deleteEventNames(path) {
    return {type: 'DELETE', path: path.concat(['eventNames'])};
  }
  /**
   * @returns {TimedQuestData}
   */
  get timedQuestData() {
    return this._hasTimedQuestData ? this._timedQuestData : TimedQuestData.default;
  }
  get hasTimedQuestData() {
    return this._hasTimedQuestData;
  }
  setTimedQuestData(path, value) {
    return {type: 'SET', path: path.concat(['timedQuestData']), value: value.toJson()};
  }
  deleteTimedQuestData(path) {
    return {type: 'DELETE', path: path.concat(['timedQuestData'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "questData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestAndAchievementData(this);
              copy._hasQuestData = true;
              copy._questData = QuestData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasQuestData) {
                return this;
              }
              const copy = new QuestAndAchievementData(this);
              copy._hasQuestData = false;
              copy._questData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasQuestData) {
            const copy = new QuestAndAchievementData(this);
            copy._hasQuestData = true;
            copy._questData = QuestData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._questData.apply(type, path.slice(1), value);
          if (newValue === this._questData) {
            return this;
          }
          const copy = new QuestAndAchievementData(this);
          copy._questData = copy._questData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "achievementData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestAndAchievementData(this);
              copy._hasAchievementData = true;
              copy._achievementData = AchievementData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAchievementData) {
                return this;
              }
              const copy = new QuestAndAchievementData(this);
              copy._hasAchievementData = false;
              copy._achievementData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasAchievementData) {
            const copy = new QuestAndAchievementData(this);
            copy._hasAchievementData = true;
            copy._achievementData = AchievementData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._achievementData.apply(type, path.slice(1), value);
          if (newValue === this._achievementData) {
            return this;
          }
          const copy = new QuestAndAchievementData(this);
          copy._achievementData = copy._achievementData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "eventNames": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestAndAchievementData(this);
              copy._hasEventNames = true;
              copy._eventNames = QuestAndAchievementEvents.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEventNames) {
                return this;
              }
              const copy = new QuestAndAchievementData(this);
              copy._hasEventNames = false;
              copy._eventNames = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasEventNames) {
            const copy = new QuestAndAchievementData(this);
            copy._hasEventNames = true;
            copy._eventNames = QuestAndAchievementEvents.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._eventNames.apply(type, path.slice(1), value);
          if (newValue === this._eventNames) {
            return this;
          }
          const copy = new QuestAndAchievementData(this);
          copy._eventNames = copy._eventNames.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "timedQuestData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new QuestAndAchievementData(this);
              copy._hasTimedQuestData = true;
              copy._timedQuestData = TimedQuestData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTimedQuestData) {
                return this;
              }
              const copy = new QuestAndAchievementData(this);
              copy._hasTimedQuestData = false;
              copy._timedQuestData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTimedQuestData) {
            const copy = new QuestAndAchievementData(this);
            copy._hasTimedQuestData = true;
            copy._timedQuestData = TimedQuestData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._timedQuestData.apply(type, path.slice(1), value);
          if (newValue === this._timedQuestData) {
            return this;
          }
          const copy = new QuestAndAchievementData(this);
          copy._timedQuestData = copy._timedQuestData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {QuestAndAchievementData} other
   * @returns {QuestAndAchievementData}
   */
  merge(other) {
    const copy = new QuestAndAchievementData(this);
    if (other._hasQuestData) {
      if (copy._hasQuestData) {
        copy._questData = copy.questData.merge(other.questData);
      } else {
        copy._questData = other._questData;
      }
      copy._hasQuestData = true;
    }
    if (other._hasAchievementData) {
      if (copy._hasAchievementData) {
        copy._achievementData = copy.achievementData.merge(other.achievementData);
      } else {
        copy._achievementData = other._achievementData;
      }
      copy._hasAchievementData = true;
    }
    if (other._hasEventNames) {
      if (copy._hasEventNames) {
        copy._eventNames = copy.eventNames.merge(other.eventNames);
      } else {
        copy._eventNames = other._eventNames;
      }
      copy._hasEventNames = true;
    }
    if (other._hasTimedQuestData) {
      if (copy._hasTimedQuestData) {
        copy._timedQuestData = copy.timedQuestData.merge(other.timedQuestData);
      } else {
        copy._timedQuestData = other._timedQuestData;
      }
      copy._hasTimedQuestData = true;
    }
    return copy;
  }
}
QuestAndAchievementData.default = new QuestAndAchievementData();
class QuestAndAchievementData_Builder {
  constructor(value) {
    this._value = new QuestAndAchievementData(value);
  }
  build() {
    return new QuestAndAchievementData(this._value);
  }
  setQuestData(value) {
    this._value._hasQuestData = true;
    this._value._questData = value;
    return this;
  }
  deleteQuestData() {
    this._value._hasQuestData = false;
    this._value._questData = null;
    return this;
  }
  setAchievementData(value) {
    this._value._hasAchievementData = true;
    this._value._achievementData = value;
    return this;
  }
  deleteAchievementData() {
    this._value._hasAchievementData = false;
    this._value._achievementData = null;
    return this;
  }
  setEventNames(value) {
    this._value._hasEventNames = true;
    this._value._eventNames = value;
    return this;
  }
  deleteEventNames() {
    this._value._hasEventNames = false;
    this._value._eventNames = null;
    return this;
  }
  setTimedQuestData(value) {
    this._value._hasTimedQuestData = true;
    this._value._timedQuestData = value;
    return this;
  }
  deleteTimedQuestData() {
    this._value._hasTimedQuestData = false;
    this._value._timedQuestData = null;
    return this;
  }
}
QuestAndAchievementData.Builder = QuestAndAchievementData_Builder;
class QuestAndAchievementData_WithParent {
  /**
   * @param {QuestAndAchievementData} value
   * @param {QuestAndAchievementData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return QuestAndAchievementData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasQuestData() {
    if (this._cachedHasQuestData === undefined) {
      if (this._value.hasQuestData) {
        this._cachedHasQuestData = true;
      } else {
        this._cachedHasQuestData = this._parent ? this._parent.hasQuestData : false;
      }
    }
    return this._cachedHasQuestData;
  }
  get questData() {
    if (!this._cachedQuestData) {
      if (this._value.hasQuestData) {
        this._cachedQuestData = new QuestData.WithParent(this._value.questData, this._parent && this._parent.hasQuestData ? this._parent.questData : null);
      } else {
        this._cachedQuestData = this._parent ? new QuestData.WithParent(QuestData.default, this._parent.questData) : QuestData.WithParent.default;
      }
    }
    return this._cachedQuestData;
  }
  get hasAchievementData() {
    if (this._cachedHasAchievementData === undefined) {
      if (this._value.hasAchievementData) {
        this._cachedHasAchievementData = true;
      } else {
        this._cachedHasAchievementData = this._parent ? this._parent.hasAchievementData : false;
      }
    }
    return this._cachedHasAchievementData;
  }
  get achievementData() {
    if (!this._cachedAchievementData) {
      if (this._value.hasAchievementData) {
        this._cachedAchievementData = new AchievementData.WithParent(this._value.achievementData, this._parent && this._parent.hasAchievementData ? this._parent.achievementData : null);
      } else {
        this._cachedAchievementData = this._parent ? new AchievementData.WithParent(AchievementData.default, this._parent.achievementData) : AchievementData.WithParent.default;
      }
    }
    return this._cachedAchievementData;
  }
  get hasEventNames() {
    if (this._cachedHasEventNames === undefined) {
      if (this._value.hasEventNames) {
        this._cachedHasEventNames = true;
      } else {
        this._cachedHasEventNames = this._parent ? this._parent.hasEventNames : false;
      }
    }
    return this._cachedHasEventNames;
  }
  get eventNames() {
    if (!this._cachedEventNames) {
      if (this._value.hasEventNames) {
        this._cachedEventNames = new QuestAndAchievementEvents.WithParent(this._value.eventNames, this._parent && this._parent.hasEventNames ? this._parent.eventNames : null);
      } else {
        this._cachedEventNames = this._parent ? new QuestAndAchievementEvents.WithParent(QuestAndAchievementEvents.default, this._parent.eventNames) : QuestAndAchievementEvents.WithParent.default;
      }
    }
    return this._cachedEventNames;
  }
  get hasTimedQuestData() {
    if (this._cachedHasTimedQuestData === undefined) {
      if (this._value.hasTimedQuestData) {
        this._cachedHasTimedQuestData = true;
      } else {
        this._cachedHasTimedQuestData = this._parent ? this._parent.hasTimedQuestData : false;
      }
    }
    return this._cachedHasTimedQuestData;
  }
  get timedQuestData() {
    if (!this._cachedTimedQuestData) {
      if (this._value.hasTimedQuestData) {
        this._cachedTimedQuestData = new TimedQuestData.WithParent(this._value.timedQuestData, this._parent && this._parent.hasTimedQuestData ? this._parent.timedQuestData : null);
      } else {
        this._cachedTimedQuestData = this._parent ? new TimedQuestData.WithParent(TimedQuestData.default, this._parent.timedQuestData) : TimedQuestData.WithParent.default;
      }
    }
    return this._cachedTimedQuestData;
  }
  update(current, parent) {
    const result = new QuestAndAchievementData_WithParent(current, parent);
    if (this._cachedQuestData && this._value.hasQuestData && current.hasQuestData) {
      if (this._value.questData === current.questData && this._parent === parent) {
        result._cachedQuestData = this._cachedQuestData;
      } else {
        result._cachedQuestData = this._cachedQuestData.update(current.questData, parent && parent.hasQuestData ? parent.questData : null);
      }
    }
    if (this._cachedAchievementData && this._value.hasAchievementData && current.hasAchievementData) {
      if (this._value.achievementData === current.achievementData && this._parent === parent) {
        result._cachedAchievementData = this._cachedAchievementData;
      } else {
        result._cachedAchievementData = this._cachedAchievementData.update(current.achievementData, parent && parent.hasAchievementData ? parent.achievementData : null);
      }
    }
    if (this._cachedEventNames && this._value.hasEventNames && current.hasEventNames) {
      if (this._value.eventNames === current.eventNames && this._parent === parent) {
        result._cachedEventNames = this._cachedEventNames;
      } else {
        result._cachedEventNames = this._cachedEventNames.update(current.eventNames, parent && parent.hasEventNames ? parent.eventNames : null);
      }
    }
    if (this._cachedTimedQuestData && this._value.hasTimedQuestData && current.hasTimedQuestData) {
      if (this._value.timedQuestData === current.timedQuestData && this._parent === parent) {
        result._cachedTimedQuestData = this._cachedTimedQuestData;
      } else {
        result._cachedTimedQuestData = this._cachedTimedQuestData.update(current.timedQuestData, parent && parent.hasTimedQuestData ? parent.timedQuestData : null);
      }
    }
    return result;
  }
}
QuestAndAchievementData_WithParent.default = new QuestAndAchievementData_WithParent(QuestAndAchievementData.default, null);
QuestAndAchievementData.WithParent = QuestAndAchievementData_WithParent;
class QuestAndAchievementData_Descriptor {
  get questData() {
    if (!this._questData) {
      this._questData = {
        name: "questData",
        Name: "QuestData",
        number: 1,
        protoType: 11,
        protoName: "quest_data",
        type: QuestData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._questData;
  }
  get achievementData() {
    if (!this._achievementData) {
      this._achievementData = {
        name: "achievementData",
        Name: "AchievementData",
        number: 2,
        protoType: 11,
        protoName: "achievement_data",
        type: AchievementData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._achievementData;
  }
  get eventNames() {
    if (!this._eventNames) {
      this._eventNames = {
        name: "eventNames",
        Name: "EventNames",
        number: 3,
        protoType: 11,
        protoName: "event_names",
        type: QuestAndAchievementEvents,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventNames;
  }
  get timedQuestData() {
    if (!this._timedQuestData) {
      this._timedQuestData = {
        name: "timedQuestData",
        Name: "TimedQuestData",
        number: 4,
        protoType: 11,
        protoName: "timed_quest_data",
        type: TimedQuestData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._timedQuestData;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.questData,
        this.achievementData,
        this.eventNames,
        this.timedQuestData,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForQuestData",
        Name: "DummyOneofForQuestData",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAchievementData",
        Name: "DummyOneofForAchievementData",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEventNames",
        Name: "DummyOneofForEventNames",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTimedQuestData",
        Name: "DummyOneofForTimedQuestData",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
QuestAndAchievementData.descriptor = new QuestAndAchievementData_Descriptor();
class PendingDailyQuestProgresses_ProgressPack_Progress {
  get descriptor() {
    return PendingDailyQuestProgresses_ProgressPack_Progress.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PendingDailyQuestProgresses_ProgressPack_Progress) {
      return value;
    }
    return PendingDailyQuestProgresses_ProgressPack_Progress.fromJson(value);
  }
  static fromJson(json) {
    const result = new PendingDailyQuestProgresses_ProgressPack_Progress();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = JsonToInt32.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue) {
      result.value = JsonToInt32.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {number}
   */
  get value() {
    return this._hasValue ? this._value : JsonToInt32.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PendingDailyQuestProgresses_ProgressPack_Progress(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new PendingDailyQuestProgresses_ProgressPack_Progress(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PendingDailyQuestProgresses_ProgressPack_Progress(this);
              copy._hasValue = true;
              copy._value = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new PendingDailyQuestProgresses_ProgressPack_Progress(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PendingDailyQuestProgresses_ProgressPack_Progress} other
   * @returns {PendingDailyQuestProgresses_ProgressPack_Progress}
   */
  merge(other) {
    const copy = new PendingDailyQuestProgresses_ProgressPack_Progress(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      copy._hasValue = true;
      copy._value = other._value;
    }
    return copy;
  }
}
PendingDailyQuestProgresses_ProgressPack_Progress.default = new PendingDailyQuestProgresses_ProgressPack_Progress();
class PendingDailyQuestProgresses_ProgressPack_Progress_Builder {
  constructor(value) {
    this._value = new PendingDailyQuestProgresses_ProgressPack_Progress(value);
  }
  build() {
    return new PendingDailyQuestProgresses_ProgressPack_Progress(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
PendingDailyQuestProgresses_ProgressPack_Progress.Builder = PendingDailyQuestProgresses_ProgressPack_Progress_Builder;
class PendingDailyQuestProgresses_ProgressPack_Progress_WithParent {
  /**
   * @param {PendingDailyQuestProgresses_ProgressPack_Progress} value
   * @param {PendingDailyQuestProgresses_ProgressPack_Progress_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PendingDailyQuestProgresses_ProgressPack_Progress.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (this._cachedValue === undefined) {
      if (this._value.hasValue) {
        this._cachedValue = this._value.value;
      } else {
        this._cachedValue = this._parent ? this._parent.value : this._value.value;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new PendingDailyQuestProgresses_ProgressPack_Progress_WithParent(current, parent);
    return result;
  }
}
PendingDailyQuestProgresses_ProgressPack_Progress_WithParent.default = new PendingDailyQuestProgresses_ProgressPack_Progress_WithParent(PendingDailyQuestProgresses_ProgressPack_Progress.default, null);
PendingDailyQuestProgresses_ProgressPack_Progress.WithParent = PendingDailyQuestProgresses_ProgressPack_Progress_WithParent;
class PendingDailyQuestProgresses_ProgressPack_Progress_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 5,
        protoName: "value",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForValue",
        Name: "DummyOneofForValue",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
PendingDailyQuestProgresses_ProgressPack_Progress.descriptor = new PendingDailyQuestProgresses_ProgressPack_Progress_Descriptor();
class PendingDailyQuestProgresses_ProgressPack {
  get descriptor() {
    return PendingDailyQuestProgresses_ProgressPack.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._progresses = [];
  }
  isEmpty() {
    if (this._progresses.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PendingDailyQuestProgresses_ProgressPack) {
      return value;
    }
    return PendingDailyQuestProgresses_ProgressPack.fromJson(value);
  }
  static fromJson(json) {
    const result = new PendingDailyQuestProgresses_ProgressPack();
    result._progresses = JsonToList(json.progresses, PendingDailyQuestProgresses_ProgressPack_Progress);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._progresses.length > 0) {
      result.progresses = ArrayToJson(this._progresses, PendingDailyQuestProgresses_ProgressPack_Progress);
    }
    return result;
  }
  /**
   * @returns {PendingDailyQuestProgresses_ProgressPack_Progress[]}
   */
  get progresses() {
    return this._progresses;
  }
  addProgresses(path, value) {
    return {type: 'ADD', path: path.concat(['progresses']), value: value.toJson()};
  }
  setProgresses(path, value) {
    return {type: 'SET', path: path.concat(['progresses']), value: ArrayToJson(value, PendingDailyQuestProgresses_ProgressPack_Progress)};
  }
  setProgressesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['progresses', key]), value: value.toJson()};
  }
  deleteProgresses(path) {
    return {type: 'DELETE', path: path.concat(['progresses'])};
  }
  deleteProgressesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['progresses', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "progresses": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PendingDailyQuestProgresses_ProgressPack(this);
              copy._progresses = [];        for (let i of value) {
                copy._progresses.push(PendingDailyQuestProgresses_ProgressPack_Progress.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PendingDailyQuestProgresses_ProgressPack(this);
              copy._progresses = copy._progresses.concat([PendingDailyQuestProgresses_ProgressPack_Progress.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._progresses.length === 0) {
                return this;
              }
              const copy = new PendingDailyQuestProgresses_ProgressPack(this);
              copy._progresses = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._progresses.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PendingDailyQuestProgresses_ProgressPack(this);
              copy._progresses = copy._progresses.slice();
              copy._progresses[path[1]] = PendingDailyQuestProgresses_ProgressPack_Progress.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PendingDailyQuestProgresses_ProgressPack(this);
              copy._progresses = copy._progresses.slice(0, path[1]).concat(copy._progresses.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._progresses.length) {
            return this;
          }
          const oldValue = this._progresses[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PendingDailyQuestProgresses_ProgressPack(this);
          copy._progresses = copy._progresses.slice();
          copy._progresses[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PendingDailyQuestProgresses_ProgressPack} other
   * @returns {PendingDailyQuestProgresses_ProgressPack}
   */
  merge(other) {
    const copy = new PendingDailyQuestProgresses_ProgressPack(this);
    copy._progresses = this._progresses.concat(other._progresses);
    return copy;
  }
}
PendingDailyQuestProgresses_ProgressPack.default = new PendingDailyQuestProgresses_ProgressPack();
PendingDailyQuestProgresses_ProgressPack.Progress = PendingDailyQuestProgresses_ProgressPack_Progress;
class PendingDailyQuestProgresses_ProgressPack_Builder {
  constructor(value) {
    this._value = new PendingDailyQuestProgresses_ProgressPack(value);
  }
  build() {
    return new PendingDailyQuestProgresses_ProgressPack(this._value);
  }
  addAllProgresses(values) {
    this._value._progresses = this._value._progresses.concat(values);
    return this;
  }
  addProgresses(value) {
    this._value._progresses = this._value._progresses.concat([value]);
    return this;
  }
  setProgresses(index, value) {
    this._value._progresses = this._value._progresses.concat();
    this._value._progresses[index] = value;
    return this;
  }
  clearProgresses() {
    this._value._progresses = [];
    return this;
  }
}
PendingDailyQuestProgresses_ProgressPack.Builder = PendingDailyQuestProgresses_ProgressPack_Builder;
class PendingDailyQuestProgresses_ProgressPack_WithParent {
  /**
   * @param {PendingDailyQuestProgresses_ProgressPack} value
   * @param {PendingDailyQuestProgresses_ProgressPack_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PendingDailyQuestProgresses_ProgressPack.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfProgresses() {
    if (!this._selfProgresses) {
      this._selfProgresses = [];
      for (let i of this._value.progresses) {
        this._selfProgresses.push(new PendingDailyQuestProgresses_ProgressPack_Progress.WithParent(i, null));
      }
    }
    return this._selfProgresses;
  }
  get inherentProgresses() {
    if (!this._inherentProgresses) {
      this._inherentProgresses = this._parent ? this._parent.progresses : [];
    }
    return this._inherentProgresses;
  }
  get progresses() {
    if (!this._allProgresses) {
      this._allProgresses = this._parent ? this._parent.progresses.concat(this.selfProgresses) : this.selfProgresses;
    }
    return this._allProgresses;
  }
  update(current, parent) {
    const result = new PendingDailyQuestProgresses_ProgressPack_WithParent(current, parent);
    if (this._selfProgresses) {
      if (this._value.progresses === current.progresses) {
        result._selfProgresses = this._selfProgresses;
      } else {
        result._selfProgresses = [];
        for (let i = 0; i < current.progresses.length; i++) {
          const oldValue = this._value.progresses[i];
          if (oldValue) {
            const oldCache = this._selfProgresses[i];
            if (oldValue === current.progresses[i]) {
              result._selfProgresses[i] = oldCache;
            } else {
              result._selfProgresses[i] = oldCache.update(current.progresses[i], null);
            }
          } else {
            result._selfProgresses[i] = new PendingDailyQuestProgresses_ProgressPack_Progress.WithParent(current.progresses[i], null);
          }
        }
      }
    }
    return result;
  }
}
PendingDailyQuestProgresses_ProgressPack_WithParent.default = new PendingDailyQuestProgresses_ProgressPack_WithParent(PendingDailyQuestProgresses_ProgressPack.default, null);
PendingDailyQuestProgresses_ProgressPack.WithParent = PendingDailyQuestProgresses_ProgressPack_WithParent;
class PendingDailyQuestProgresses_ProgressPack_Descriptor {
  get progresses() {
    if (!this._progresses) {
      this._progresses = {
        name: "progresses",
        Name: "Progresses",
        number: 1,
        protoType: 11,
        protoName: "progresses",
        type: PendingDailyQuestProgresses_ProgressPack_Progress,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._progresses;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.progresses,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
PendingDailyQuestProgresses_ProgressPack.descriptor = new PendingDailyQuestProgresses_ProgressPack_Descriptor();
export class PendingDailyQuestProgresses {
  get descriptor() {
    return PendingDailyQuestProgresses.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUuid = false;
    this._uuid = null;
    this._progressPacks = [];
  }
  isEmpty() {
    if (this._hasUuid) return false;
    if (this._progressPacks.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PendingDailyQuestProgresses) {
      return value;
    }
    return PendingDailyQuestProgresses.fromJson(value);
  }
  static fromJson(json) {
    const result = new PendingDailyQuestProgresses();
    if (json.uuid != null) {
      result._hasUuid = true;
      result._uuid = JsonToString.fromJson(json.uuid);
    }
    result._progressPacks = JsonToList(json.progressPacks, PendingDailyQuestProgresses_ProgressPack);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUuid) {
      result.uuid = JsonToString.toJson(this._uuid);
    }
    if (this._progressPacks.length > 0) {
      result.progressPacks = ArrayToJson(this._progressPacks, PendingDailyQuestProgresses_ProgressPack);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get uuid() {
    return this._hasUuid ? this._uuid : JsonToString.default;
  }
  get hasUuid() {
    return this._hasUuid;
  }
  setUuid(path, value) {
    return {type: 'SET', path: path.concat(['uuid']), value};
  }
  deleteUuid(path) {
    return {type: 'DELETE', path: path.concat(['uuid'])};
  }
  /**
   * @returns {PendingDailyQuestProgresses_ProgressPack[]}
   */
  get progressPacks() {
    return this._progressPacks;
  }
  addProgressPacks(path, value) {
    return {type: 'ADD', path: path.concat(['progressPacks']), value: value.toJson()};
  }
  setProgressPacks(path, value) {
    return {type: 'SET', path: path.concat(['progressPacks']), value: ArrayToJson(value, PendingDailyQuestProgresses_ProgressPack)};
  }
  setProgressPacksByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['progressPacks', key]), value: value.toJson()};
  }
  deleteProgressPacks(path) {
    return {type: 'DELETE', path: path.concat(['progressPacks'])};
  }
  deleteProgressPacksByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['progressPacks', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "uuid": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PendingDailyQuestProgresses(this);
              copy._hasUuid = true;
              copy._uuid = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUuid) {
                return this;
              }
              const copy = new PendingDailyQuestProgresses(this);
              copy._hasUuid = false;
              copy._uuid = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "progressPacks": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PendingDailyQuestProgresses(this);
              copy._progressPacks = [];        for (let i of value) {
                copy._progressPacks.push(PendingDailyQuestProgresses_ProgressPack.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PendingDailyQuestProgresses(this);
              copy._progressPacks = copy._progressPacks.concat([PendingDailyQuestProgresses_ProgressPack.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._progressPacks.length === 0) {
                return this;
              }
              const copy = new PendingDailyQuestProgresses(this);
              copy._progressPacks = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._progressPacks.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PendingDailyQuestProgresses(this);
              copy._progressPacks = copy._progressPacks.slice();
              copy._progressPacks[path[1]] = PendingDailyQuestProgresses_ProgressPack.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PendingDailyQuestProgresses(this);
              copy._progressPacks = copy._progressPacks.slice(0, path[1]).concat(copy._progressPacks.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._progressPacks.length) {
            return this;
          }
          const oldValue = this._progressPacks[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PendingDailyQuestProgresses(this);
          copy._progressPacks = copy._progressPacks.slice();
          copy._progressPacks[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PendingDailyQuestProgresses} other
   * @returns {PendingDailyQuestProgresses}
   */
  merge(other) {
    const copy = new PendingDailyQuestProgresses(this);
    if (other._hasUuid) {
      copy._hasUuid = true;
      copy._uuid = other._uuid;
    }
    copy._progressPacks = this._progressPacks.concat(other._progressPacks);
    return copy;
  }
}
PendingDailyQuestProgresses.default = new PendingDailyQuestProgresses();
PendingDailyQuestProgresses.ProgressPack = PendingDailyQuestProgresses_ProgressPack;
class PendingDailyQuestProgresses_Builder {
  constructor(value) {
    this._value = new PendingDailyQuestProgresses(value);
  }
  build() {
    return new PendingDailyQuestProgresses(this._value);
  }
  setUuid(value) {
    this._value._hasUuid = true;
    this._value._uuid = value;
    return this;
  }
  deleteUuid() {
    this._value._hasUuid = false;
    this._value._uuid = null;
    return this;
  }
  addAllProgressPacks(values) {
    this._value._progressPacks = this._value._progressPacks.concat(values);
    return this;
  }
  addProgressPacks(value) {
    this._value._progressPacks = this._value._progressPacks.concat([value]);
    return this;
  }
  setProgressPacks(index, value) {
    this._value._progressPacks = this._value._progressPacks.concat();
    this._value._progressPacks[index] = value;
    return this;
  }
  clearProgressPacks() {
    this._value._progressPacks = [];
    return this;
  }
}
PendingDailyQuestProgresses.Builder = PendingDailyQuestProgresses_Builder;
class PendingDailyQuestProgresses_WithParent {
  /**
   * @param {PendingDailyQuestProgresses} value
   * @param {PendingDailyQuestProgresses_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PendingDailyQuestProgresses.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUuid() {
    if (this._cachedHasUuid === undefined) {
      if (this._value.hasUuid) {
        this._cachedHasUuid = true;
      } else {
        this._cachedHasUuid = this._parent ? this._parent.hasUuid : false;
      }
    }
    return this._cachedHasUuid;
  }
  get uuid() {
    if (this._cachedUuid === undefined) {
      if (this._value.hasUuid) {
        this._cachedUuid = this._value.uuid;
      } else {
        this._cachedUuid = this._parent ? this._parent.uuid : this._value.uuid;
      }
    }
    return this._cachedUuid;
  }
  get selfProgressPacks() {
    if (!this._selfProgressPacks) {
      this._selfProgressPacks = [];
      for (let i of this._value.progressPacks) {
        this._selfProgressPacks.push(new PendingDailyQuestProgresses_ProgressPack.WithParent(i, null));
      }
    }
    return this._selfProgressPacks;
  }
  get inherentProgressPacks() {
    if (!this._inherentProgressPacks) {
      this._inherentProgressPacks = this._parent ? this._parent.progressPacks : [];
    }
    return this._inherentProgressPacks;
  }
  get progressPacks() {
    if (!this._allProgressPacks) {
      this._allProgressPacks = this._parent ? this._parent.progressPacks.concat(this.selfProgressPacks) : this.selfProgressPacks;
    }
    return this._allProgressPacks;
  }
  update(current, parent) {
    const result = new PendingDailyQuestProgresses_WithParent(current, parent);
    if (this._selfProgressPacks) {
      if (this._value.progressPacks === current.progressPacks) {
        result._selfProgressPacks = this._selfProgressPacks;
      } else {
        result._selfProgressPacks = [];
        for (let i = 0; i < current.progressPacks.length; i++) {
          const oldValue = this._value.progressPacks[i];
          if (oldValue) {
            const oldCache = this._selfProgressPacks[i];
            if (oldValue === current.progressPacks[i]) {
              result._selfProgressPacks[i] = oldCache;
            } else {
              result._selfProgressPacks[i] = oldCache.update(current.progressPacks[i], null);
            }
          } else {
            result._selfProgressPacks[i] = new PendingDailyQuestProgresses_ProgressPack.WithParent(current.progressPacks[i], null);
          }
        }
      }
    }
    return result;
  }
}
PendingDailyQuestProgresses_WithParent.default = new PendingDailyQuestProgresses_WithParent(PendingDailyQuestProgresses.default, null);
PendingDailyQuestProgresses.WithParent = PendingDailyQuestProgresses_WithParent;
class PendingDailyQuestProgresses_Descriptor {
  get uuid() {
    if (!this._uuid) {
      this._uuid = {
        name: "uuid",
        Name: "Uuid",
        number: 1,
        protoType: 9,
        protoName: "uuid",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._uuid;
  }
  get progressPacks() {
    if (!this._progressPacks) {
      this._progressPacks = {
        name: "progressPacks",
        Name: "ProgressPacks",
        number: 2,
        protoType: 11,
        protoName: "progress_packs",
        type: PendingDailyQuestProgresses_ProgressPack,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._progressPacks;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.uuid,
        this.progressPacks,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUuid",
        Name: "DummyOneofForUuid",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
PendingDailyQuestProgresses.descriptor = new PendingDailyQuestProgresses_Descriptor();
